var readSet = 0;
var writeSet = 0;
var deleteSet = 0;
var baseURL = '';
var adminUrl = '';
var regionDateFromat='';
var sno = 0;
var tot_hours =0;
var tot_usedemp_hours =0;
var tot_namedemp_hours =0;
var from_date = '';
var to_date = '';
var regionDateFromat1='mm-dd-yyyy';
var empRegionDateFormate = 'mm/dd/yy';
var regionDateFromat2='dd-mm-yyyy';
var regionDateFromat3='yyyy-mm-dd';
var Edithours_taken_tot =0;
var filterSearchArray = ['sort','order','filter_status','filter_project_id','filter_emp_id','filter_from_date','filter_to_date','filter_task_status', 'filter_project_status','filter_workitem_id','project_type_id','orderby','filter_client_id','filter_company_id','filter_department_id', 'filter_timesheet_id', 'filter_leave_id', 'filter_asset_type_id', 'filter_asset_category_id', 'filter_asset_subcategory_id', 'filter_asset_location_id', 'filter_asset_id', 'filter_manager_id', 'filter_region_id', 'filter_project_type', 'filter_type_id'];

var total_hourss =0;

  $(document).ready(function(){

         $(".regular").slick({
        //dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });


// if($("#modalstatus").length){

  if($("#modalstatus").val()=="1"){
    console.log('yes modal');
   // $(window).on('load', function() {
        $('#booking_hours_create').modal('show');
    // });
 }
 else{
   console.log('no modal');
 }

// }


  window.setTimeout(function() {
    $('.alert').fadeOut('slow');
  }, 20000);

  baseURL = funGetValueWe("txtBaseUrl");
  adminUrl = funGetValueWe("txtAdminUrl");
  currentUrl = funGetValueWe("currentUrl");
  regionDateFromat = funGetValueWe('txtRegionDateFormat');

  $('.date').datepicker({'autoHide':true,'format':regionDateFromat,changeYear: true, zIndex: 1100});

  $(".monthPicker").datepicker({
    'autoHide':true,
    'format':'mm-yyyy',
    changeMonth: true,
    changeYear: true, 
    zIndex: 1100,
  });

  var lastDate = new Date();
  lastDate.setDate(lastDate.getDate() - 10);
 $('.initial_date').datepicker({'autoHide':true,'format':regionDateFromat,changeYear: true});
 $(".initial_date").datepicker('setDate', lastDate);
  //$('.date').datepicker({'autoHide':true,'format':'dd-mm-yyyy'});

  //$('.date-time').datetimepicker({'format':'dd-mm-yyyy hh:ii:ss','autoclose':true});

  //$('.chosen-select').chosen();

  /*Input accepts only Aplha Numeric Values*/
  $(function () {
    $(".only-alpha-numeric").keypress(function (e) {
      var keyCode = e.keyCode || e.which;
      $("#lblError").html("");
      //Regex for Valid Characters i.e. Alphabets and Numbers.
      var regex = /^[A-Za-z0-9]+$/;
      //Validate TextBox value against the Regex.
      var isValid = regex.test(String.fromCharCode(keyCode));
      if (!isValid) {
        $("#lblError").html("Only Alphabets and Numbers allowed.");
      }
      return isValid;
    });
  });

  /*Prevent form multiple submits*/
  $(function () {
    $(".form-prevent-multiple-submits").on("submit", function(){
      $(".button-prevent-multiple-submits").attr("disabled", "true");
    });
  });

  $(".only-number").on("input", function(evt) {
   var self = $(this);
   self.val(self.val().replace(/[^0-9\.]/g, ''));
   if ((evt.which != 46 || self.val().indexOf('.') != -1) && (evt.which < 48 || evt.which > 57))
   {
     evt.preventDefault();
   }
  });

  var txtSno = funGetValue('txtSno');
  // console.log(txtSno);
  if(txtSno){
    sno = txtSno;
    // console.log(sno);
  }

    $("#formResetPassword").submit(function(event){
      var password = funGetValueWe('txt_new_password');
      var confirm = funGetValueWe('txt_confirm_password');
      if(password != confirm) {
        fun_error_message("password and confirm does mot match");
      }
      else {
        $.ajax({                                // Ajax call
            type: "POST",
            dataType: "JSON",
            url: baseURL+adminUrl+"/ajax/reset-password",
             data:'_token='+funGetToken()+'&password='+password,
                success: function(response) {
                    if(response.status==true)
                    {
                        // $("#span_log_count").css("display","none");
                        funSetValue("txt_new_password",'');
                        funSetValue("txt_confirm_password",'');
                        funCloseModal("modalResetPassword");
                        funSuccessMessage(response.message);
                    }
                    else
                    {
                        funErrorMessage('Something went wrong');
                    }
                },
            error: function() {
                funHideLoader();
                funErrorMessage("Error occured !!! Please try after sometime.");
            }
        });
      }
      event.preventDefault();
    });


});
//document ends

function funGetHolidayCalendar(){
  adminUrl = (adminUrl) ? adminUrl : 'tadmin';
  let calendarURL = `${baseURL}${adminUrl}/ajax/holiday-calendar`
    $.ajax({
        type: "GET",
        dataType: "JSON",
        url: calendarURL,
        data:'_token='+funGetToken(),
        success: function(response) {
            if (response.status == true) {
                $('.holiday-calendar').fullCalendar({
                    header: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'month,basicWeek,basicDay'
                    },
                    defaultDate: new Date(),
                    editable: false,
                    events: response.events,
                    eventLimit: true,
                    isRTL: $('html').attr('dir') == 'rtl' ? true : false
                });
            } else {
                console.log("Calendar data is empty");
            }
          },
          error: function() {
                console.log("Calendar data not found");
          }
    });
}

function fun_check_all(type)
{
  if(type=='read' && readSet == 0) {
    $(".checkRead").prop("checked",true);
    readSet = 1;
  }
  else if(type=='read' && readSet == 1) {
    $(".checkRead").prop("checked",false);
    readSet = 0;
  }

  if(type=='write' && writeSet == 0) {
    $(".checkWrite").prop("checked",true);
    writeSet = 1;
  }
  else if(type=='write' && writeSet == 1) {
    $(".checkWrite").prop("checked",false);
    writeSet = 0;
  }

  if(type=='delete' && deleteSet == 0) {
    $(".checkDelete").prop("checked",true);
    deleteSet = 1;
  }
  else if(type=='delete' && deleteSet == 1) {
    $(".checkDelete").prop("checked",false);
    deleteSet = 0;
  }

}

function funLogout()
{
  funOpenModal("modalSystemLogout");
}

function funOpenModal(id,arg, activities_id='', emp_id='',task_id='')
{
  if (activities_id != '') {
    funGetActivitiesModel(activities_id);
    funGetProjectWbsModal(activities_id,emp_id,task_id);
  }
  if(arg == true){
    $('#'+id).modal({backdrop: 'static', keyboard: false});
  }
  $("#"+id).modal("show");

}

function funCloseModal(id)
{
  // $('#progressReport').remove();
  $('#activityProgress tr#progressReport').remove();
  $('#resourceActivityModalProgress tr#resourceActivityProgress').remove();
  $("#"+id).modal("hide");
}

function funLogoutConfirm()
{
    var base_url = funGetValueWe("txtBaseUrl");
    window.location = base_url+'tadmin/logout';
}

function funGetValueWe(id)
{
  return $.trim($("#"+id).val());
}

function funGetValueWeClass(id)
{
  return $.trim($("."+id).val());
}

function funActivityModal(id,arg,activities_id)
{
  funResourceActivitiesModel(activities_id);
  // console.log(arg);
  if(arg == true){
    $('#'+id).modal({backdrop: 'static', keyboard: false});
  }
  $("#"+id).modal("show");
}


function funResourceActivitiesModel(activities_id)
{
  // Ajax call
  $.ajax({
    type: "GET",
    url: baseURL+adminUrl+"/reports/progress-wbs/resource-ajax",
    data: '_token='+funGetToken()+'&activities_id='+activities_id,
    success: function(response) {
      // console.log(response);
      if (response) {
        $.each(response, function(index, value){
          var _template = '<tr id="resourceActivityProgress">';
            _template += '<td>'+value.task_name+'</td>';
            _template += '<td>'+value.emp_name+'</td>';
            _template += '<td>'+value.start_date+'</td>';
            _template += '<td>'+value.target_date+'</td>';
            _template += '<td id="resource-hourstaken"> '+funResourceTotalHours(value.emp_id,value.activities_id) +'</td>';
            _template += '<td>'+value.weighter_score+'</td>';
          $('#resourceActivityModalProgress').append(_template);
        });
      } else {
        $('#resourceActivityModalProgress tr#resourceActivityProgress').remove();
      }

    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funResourceTotalHours(emp_id, activities_id)
{
  // Ajax call
  $.ajax({
    type: "GET",
    url: baseURL+adminUrl+"/reports/project-hours",
    data: '_token='+funGetToken()+'&activities_id='+activities_id+'&emp_id='+emp_id,
    success: function(response) {
      console.log('HOURS----->',response);
       $("td#resource-hourstaken").html('');
       $("td#resource-hourstaken").html(response);
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funGetProjectWbsModal(activities_id,emp_id,task_id)
{
  funShowLoader();
  // $('.loading-gif').css('display','block');
  // Ajax call
  $.ajax({
    type: "GET",
    url: baseURL+adminUrl+"/reports/project-wbs/resource-hours",
    data: '_token='+funGetToken()+'&activities_id='+activities_id+'&emp_id='+emp_id+'&task_id='+task_id,
    success: function(response) {
      funHideLoader();
      // console.log(response);
      $('#projectWbsProgress').html('');
      if (response) {
        // $('.loading-gif').css('display','none');
        $.each(response, function(index, value){
          var  _template = '<tr id="projectWbsReport">';
            // _template += '<td>'+value.project_name+'</td>';
            _template += '<td>'+value.timesheet_date+'</td>';
            _template += '<td>'+value.task_name+'</td>';
            _template += '<td>'+value.emp_name+'</td>';
            _template += '<td>'+value.activities_name+'</td>';
             _template += '<td>'+value.hours_taken+'</td>';
            // _template += '<td><div class="progress"><div data-popup="tooltip" title="" class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="'+value.report_progress+'" aria-valuemin="0" aria-valuemax="'+value.report_progress+'" style="width:'+value.report_progress+'%">'+value.report_progress+'%</div></div></td></tr>';
          $('#projectWbsProgress').append(_template);
        });

      } else {
        funHideLoader();
        $('#projectWbsProgress tr#projectWbsReport').remove();
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });

}

function funGetActivitiesModel(activities_id)
{
  // Ajax call
  $.ajax({
    type: "GET",
    url: baseURL+adminUrl+"/reports/progress-report/progress-report-model",
    data: '_token='+funGetToken()+'&activities_id='+activities_id,
    success: function(response) {
       $('#activityProgress').html('');
      // console.log(response);
      if (response) {
        $.each(response, function(index, value){
          var  _template = '<tr id="progressReport">';
            _template += '<td>'+value.project_name+'</td>';
            _template += '<td>'+value.work_item_name+'</td>';
            _template += '<td>'+value.activities_name+'</td>';
            _template += '<td>'+value.task_name+'</td>';
            _template += '<td>'+value.emp_name+'</td>';
            _template += '<td><div class="progress"><div data-popup="tooltip" title="" class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="'+value.report_progress+'" aria-valuemin="0" aria-valuemax="'+value.report_progress+'" style="width:'+value.report_progress+'%">'+value.report_progress+'%</div></div></td></tr>';
          $('#activityProgress').append(_template);
        });

      } else {
        $('#activityProgress tr#progressReport').remove();
      }
    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    }
  });

}

function funGetToken()
{
    return $("input[name=_token]").val();
}

function funShowLoader()
{
  $('body').addClass('loading').addClass('overlay').loader('show', {
      loader: false,
      overlay: true
  });
  return true;
}

 $(".stop-enter .disable-enter").keypress(function(event){
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == '13') {
        event.preventDefault();
        event.stopPropagation();
      }
    });

function funHideLoader()
{
  $('body').removeClass('loading').loader('hide');
  return true;
}

function funSuccessMessage(msg)
{
     toastr.clear();
      toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-bottom-center",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr.success(msg);
    return true;
}

function funErrorMessage(msg) {
    toastr.clear();
   toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-bottom-center",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    toastr.error(msg);
    return true;
}

function funSetAdminLeftBar()
{
  var token = $("input[name='_token']").val();
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/ajax/set-admin-left-menu",
    data: '_token='+token,
    success: function(response) {

    },
    error: function() {
      console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSetValue(id,value)
{
  $("#"+id).val(value);
}

function funGetValue(id)
{
  return encodeURIComponent($.trim($("#"+id).val()));
}

/* start Assign resource */
function addIntentEntry()
{

  var task_id = funGetValueWe("seltask_id");
  var emp_id = funGetValueWe("selemp_id");
  var project_start_date = funGetValueWe("txtproject_start_date");
  var target_date = funGetValueWe("txttarget_date");
  var hour = funGetValueWe("txthour");
  var weighter_score = funGetValueWe("txtweighterscore");

  if(task_id == '' )
  {
    funErrorMessage("Please select task");
  }
  else {

    var result = task_id.split(' - ');
                var task_name = result[1];
    var emp = emp_id.split('-');
                var emp_name = emp[1];
//alert (result);
     var _template = '<tr id="intentItem'+sno+'">';
    _template += '<td id="td_task_name'+sno+'">'+task_name+'</td>';
    _template += '<td id="td_emp_name'+sno+'">'+emp_name+'</td>';
    _template += '<td id="td_project_start_date'+sno+'">'+project_start_date+'</td>';
    _template += '<td id="td_target_date'+sno+'">'+target_date+'</td>';
    _template += '<td id="td_hour'+sno+'">'+hour+'</td>';
    _template += '<td id="td_weighter_score'+sno+'">'+weighter_score+'</td>';

    _template +='<input type="hidden" id="task_id'+sno+'" name="intentItem['+sno+'][task_id]" value="'+task_id+'" />';
    _template +='<input type="hidden" id="emp_id'+sno+'" name="intentItem['+sno+'][emp_id]" value="'+emp_id+'" />';
    _template +='<input type="hidden" id="project_start_date'+sno+'" name="intentItem['+sno+'][project_start_date]" value="'+project_start_date+'" />';
    _template +='<input type="hidden" id="target_date'+sno+'" name="intentItem['+sno+'][target_date]" value="'+target_date+'" />';
    _template +='<input type="hidden" id="hour'+sno+'" name="intentItem['+sno+'][hour]" value="'+hour+'" />';
    _template +='<input type="hidden" id="weighter_score'+sno+'" name="intentItem['+sno+'][weighter_score]" value="'+weighter_score+'" />';
    _template += '<td style="display:flex;"><div style="margin-right:10px;"><button type="button" onclick="funEditIntentEntry('+sno+')" class="btn btn-primary btn-sm"> <i class="fa fa-edit"> </i> </button>';
    _template += ' </div><div><button type="button" onclick="funRemoveIntentEntry('+sno+')" class="btn btn-danger btn-sm"> <i class="fa fa-close"> </i> </button> </div> </td>';

    $("#tbodyIntetEntries").append(_template);

    clearIntentEntry(project_start_date,target_date);
    gotoFocus('seltask_id');
    sno++;
  }
}
function funRemoveIntentEntry(sno)
{
  $("#intentItem"+sno).remove();
}

function clearIntentEntry(project_start_date,target_date)
{
  funSetValue("seltask_id","");
  funSetValue("selemp_id","");
  funSetValue("txtproject_start_date",project_start_date);
  funSetValue("txttarget_date",target_date);
  funSetValue("txthour","");
  funSetValue("txtweighterscore","");
}
function gotoFocus(id)
{
  $("#"+id).focus();
}

function funTimesheetUpdateManager(status,id)
{
  funShowLoader();
  $.ajax({                // Ajax call
    type: "POST",
    url: baseURL+adminUrl+"/project/approve-hours/update-status",
    data: '_token='+funGetToken()+'&id='+id+'&status='+status,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          $("#butApprove"+id).remove();
          $("#butReject"+id).remove();
          $("#butReview"+id).remove();
          $("#spanStatus"+id).html(response.status_msg);
          // console.log(response.status_msg);
          // console.log(response.message);
          funSuccessMessage(response.message);
        }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
    }
  });
}

function funTimesheetApproveManager(status,id,isClientApprove=false)
{
  funShowLoader();
  var comment =funGetValueWe('approvercomment');
  $.ajax({
    type: "POST",
    url: baseURL+adminUrl+"/project/approve-hours/approve-timesheet",
    data: '_token='+funGetToken()+'&id='+id+'&status='+status+'&comments='+comment,
    success: function(response) {
      funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
          if(isClientApprove) {
            window.location.href = baseURL+adminUrl+'/timecard/approve-timecard';
          } else {
            window.location.href = baseURL+adminUrl+'/project/approve-hours';
          }
          $("#butApprove"+id).remove();
          $("#butRejectNeedReview"+id).remove();
          $(".ajax_resp").html(response.status_msg);
         // $("#butReview"+id).remove();
          $("#spanStatus"+id).html(response.status_msg);
        }
    },
    error: function() {
      funHideLoader();
      if(isClientApprove) {
        window.location.href = baseURL+adminUrl+'/timecard/approve-timecard';
      } else {
        window.location.href = baseURL+adminUrl+'/project/approve-hours';
      }
      // packiaraj 28Apr2021 funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funTimesheetSendForApproval(status,id)
{
  funShowLoader();
  funHideToolTip();
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/booking-hours/send-approval",
    data: '_token='+funGetToken()+'&id='+id+'&status='+status,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          $("#butSendForApproval"+id).remove();
          $("#butComments"+id).remove();
          $('#table-row').css('color','');
          $("#spanStatus"+id).html(response.status_msg);
          // console.log(response.status_msg);
          // console.log(response.message);
          funSuccessMessage(response.message);
        } else {
          funHideLoader();
          funErrorMessage("Something went wrong");
        }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
    }
  });
}

function funLeaveApproveManager(status,id)
{
  funShowLoader();
  // console.log(id);
  $.ajax({
    // Ajax call
    type: "POST",
    url: baseURL+adminUrl+"/ajax/leave-approval",
    data: '_token='+funGetToken()+'&id='+id+'&status='+status,
    success: function(response) {
      funHideLoader();
      if(response.status == true) {
        funSuccessMessage(response.message);
        window.location.href = baseURL+adminUrl+'/'+response.menu_url;
        $("#butApprove"+id).remove();
        $("#butRejectNeedReview"+id).remove();
        $(".ajax_resp").html(response.status_msg);
       $("#butReview"+id).remove();
        $("#spanStatus"+id).html(response.status_msg);

        // console.log(response.status_msg);
        // console.log(response.message);
      } else {
        funHideLoader();
        funErrorMessage("Something went wrong");
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funEmpLeaveApproveManager(status,id)
{
  funShowLoader();
  $.ajax({
    type: "POST",
    url: baseURL+adminUrl+"/ajax/employee-leave-approval",
    data: '_token='+funGetToken()+'&id='+id+'&status='+status,
    success: function(response) {
      funHideLoader();
      if(response.status == true) {
        funSuccessMessage(response.message);
        window.location.href = baseURL+adminUrl+'/'+response.menu_url;
        $("#butApprove"+id).remove();
        $("#butRejectNeedReview"+id).remove();
        $(".ajax_resp").html(response.status_msg);
       $("#butReview"+id).remove();
        $("#spanStatus"+id).html(response.status_msg);

        // console.log(response.status_msg);
        // console.log(response.message);
      } else {
        funHideLoader();
        funErrorMessage("Something went wrong");
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

//funtion Ajax drop down - project to work item
function funAjaxSelWorkItem(id)
{
  if (id) {
  funShowLoader();
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/assign_resource/ajax",
    data: '_token='+funGetToken()+'&project_id='+id,
    success: function(response) {
      funHideLoader();
        if(response) {
            $('#work_item').empty();
            $('#selemp_id').empty();
            $('#activities_id').empty();
            $('#work_item').focus;
            console.log(response.workItem);
            $('#work_item').append('<option value="">-- Select Workitem --</option>');
            $.each(response.workItem, function(key, value){
            $('select[name="work_item_id"]').append('<option value="'+ value.work_item_id +'">' + value.work_item_name+ '</option>');
         });
            $('#selemp_id').focus;
            $('#selemp_id').append('<option value="">-- Select Resources --</option>');
            $.each(response.resources, function(key,value){
              $('select[name="emp_id"]').append('<option value="'+value.emp_id+' - '+value.emp_name+'">' + value.emp_name+ '</option>');
            });

                  }else{
                    funHideLoader();
                    $('#work_item').empty();
                    $('#activities_id').empty();
                  }
   }
  });

}else{
    funHideLoader();
      $('#work_item').empty();
      $('#activities_id').empty();
     }

}
// function end


//funtion for Book Hours project workitem task dropdown change

function funAjaxSelWorkItemAndTask(id, checkWarning=1)
{
  if (id)
  {
    funShowLoader();
    var result = id.split(' - ');
                var project_id = result[0];

    let projectBillableType= $('#selproject_id').find(':selected').attr('data-is_billable_project_type');

    if(Number(projectBillableType)) {
        $('#billing_type_id').find('option').removeAttr('disabled');
    } else {
        $('#billing_type_id').find('option').removeAttr('disabled');
        $('#billing_type_id').find('option').each(function() {
            // Get the value of the data-billable_type attribute
            var billableType = $(this).data('billable_type');
            var value = $(this).val();
          
            // If the billableType does not equal the projectBillableType, set the disabled attribute
            if ((billableType != projectBillableType) && (value)) {
              $(this).attr('disabled', true);
            }
        });
    }

    var option = $('#billing_type_id').find(`option[data-billable_type=${projectBillableType}]`);
    option.prop('selected', true);
            

  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/book-hours/ajax",
    data: '_token='+funGetToken()+'&project_id='+project_id,
    success: function(response) {
      funHideLoader();
        if(response) {
            $('#selwork_item_id').empty();
            $('#selwork_item_id').focus;
            $('#selwork_item_id').append('<option value="">-- Select Workitem --</option>');
            $.each(response, function(key, value){
            $('select[name="work_item_id"]').append('<option value="'+ value.work_item_id +' - '+ value.work_item_name +'">' + value.work_item_name+ '</option>');
         });
                  }else{
                    funHideLoader();
                    $('#selwork_item_id').empty();
                    $('#selactivities_id').empty();
                    $('#seltask_id').empty();
                  }
   }
  });

  if(checkWarning) {
    
    let projectEndDateStr= $('#selproject_id').find(':selected').attr('data-project_end_date');

    let urlParams = new URLSearchParams(window.location.search);
    let timesheetStartDate = atob(urlParams.get('cur_date'));

    let projectEndDate = new Date(projectEndDateStr);
    let tsStartDate = new Date(timesheetStartDate);
  
    if(tsStartDate > projectEndDate) {
      $('span.warning-project-name').text(result[1])
      $('#booking_hours_warning').modal({backdrop: 'static', keyboard: false},'show');
    }
  }


}else{
  funHideLoader();
      $('#selwork_item_id').empty();
      $('#selactivities_id').empty();
      $('#seltask_id').empty();
     }

}
//funtion end

function resetSelProject() {
  $('#selproject_id').val('');
  $('#selwork_item_id').empty();
  $('#selactivities_id').empty();
  $('#seltask_id').empty();
  $('#billing_type_id').val('');
  $('#selproject_id').focus;
  $('#booking_hours_warning').modal('hide');
  $('span.warning-project-name').text('');
  
}

function funGetProjectWorkItem(id){
  if (id) {
    funShowLoader();
    $.ajax({                // Ajax call
      type: "GET",
      url: baseURL+adminUrl+"/ajax/get-project-workItem",
      data: '_token='+funGetToken()+'&project_id='+id,
      success: function(response) {
         // console.log(response);
         funHideLoader();
        if(response) {
          $('#filter_workitem_id').empty();
          $('#filter_workitem_id').focus;
          $('#filter_workitem_id').append('<option value="">-- Select Workitem --</option>');
          $.each(response, function(key, value){
          $('select[name="filter_workitem_id"]').append('<option value="'+ value.work_item_id +'">' + value.work_item_name+'</option>');
          });
        } else {
          $('#filter_workitem_id').empty();
        }
     }
    });

  } else {
    funHideLoader();
    $('#filter_workitem_id').empty();
  }
}


// funtion for activities starts


function funAjaxSelActivities_Assign(id)
{
  if (id)
  {
    funShowLoader();
    var result = id.split(' - ');
                var work_item_id = result[0];

                console.log(work_item_id);

  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/assign_resource/ajaxactivities",
    data: '_token='+funGetToken()+'&work_item_id='+work_item_id,
    success: function(response) {
      funHideLoader();
        if(response) {
            $('#activities_id').empty();
            $('#activities_id').focus;
            $('#activities_id').append('<option value="">-- Select Activities --</option>');
            $.each(response, function(key, value){
            $('select[name="activities_id"]').append('<option value="'+ value.activities_id +' - '+ value.activities_name +'">' + value.activities_name+ '</option>');
         });
                  }else{
                    funHideLoader();
                    $('#activities_id').empty();
                  }
   }
  });

}else{
  funHideLoader();
      $('#activities_id').empty();
     }

}
// function for activities end


function getAjaxAssignedList(activities_id){

  if (activities_id)
  {
    funShowLoader();
    // console.log(projectId, workItemId);
    var result = activities_id.split(' - ');
    var activities_id = result[0];
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/assign_resource/ajaxAssignedList",
    data: '_token='+funGetToken()+'&activities_id='+activities_id,
    success: function(response) {
      funHideLoader();
        if(response) {
         //   $('#showtabledetails').empty();
            $('#tbodyviewEntries').empty();
            $('#showtabledetails').focus;
            $('#showtabledetails').append('');
            // $('#seltask_id').empty();

            var _template = '';
            $.each(response, function(key, value){
              // $('<tr>').append('<td>' + value.activities_name+ '</td><td>' + value.activities_name+ '</td><td>'+ value.activities_name+ '</td><td>' + value.activities_name+ '</td><td>' + value.activities_name+ '</td></tr>');

              _template += '<tr>';
              _template += '<td>'+value.task_name+'</td>';
              _template += '<td>'+value.emp_name+'</td>';
              _template += '<td>'+value.start_date+'</td>';
              _template += '<td>'+value.target_date+'</td>';
              _template += '<td>'+(value.hour == null ? 0 : value.hour)+'</td>';
              _template += '<td>'+value.weighter_score+'</td>';
              _template += '</tr>';
            });
            $('#tbodyviewEntries').append(_template);
            } else {
              funHideLoader();
              $('#activities_id').empty();
            }
   }
  });

}else{
    funHideLoader();
      $('#activities_id').empty();
     }

}

//funtion for Book Hours task dropdown change

function funAjaxSelTask(id)
{
  if (id)
  {
    funShowLoader();
    var result = id.split(' - ');
                var activities_id = result[0];

  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/book-hours/ajaxtask",
    data: '_token='+funGetToken()+'&activities_id='+activities_id,
    success: function(response) {
      // console.log(response);
      funHideLoader();
        if(response) {
            $('#seltask_id').empty();
            $('#seltask_id').focus;
            $('#seltask_id').append('<option value="">-- Select Task --</option>');
            $.each(response, function(key, value){
            $('select[name="task_id"]').append('<option value="'+ value.task_id +' - '+ value.task_name +'">' + value.task_name+ '</option>');
         });
                  }else{
                    funHideLoader();
                    $('#seltask_id').empty();
                  }
   }
  });

}else{
  funHideLoader();
      $('#seltask_id').empty();
     }

}
//funtion end

//funtion for Book Hours ACTIVITIES dropdown change

function funAjaxSelActivities(id)
{
  if (id)
  {
    funShowLoader();
    var result = id.split(' - ');
                var work_item_id = result[0];

  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/book-hours/ajaxactivities",
    data: '_token='+funGetToken()+'&work_item_id='+work_item_id,
    success: function(response) {
      funHideLoader();
        if(response) {
            $('#selactivities_id').empty();
            $('#selactivities_id').focus;
            $('#selactivities_id').append('<option value="">-- Select Activities --</option>');
            $.each(response, function(key, value){
            $('select[name="activities_id"]').append('<option value="'+ value.activities_id +' - '+ value.activities_name +'">' + value.activities_name+ '</option>');
         });
                  }else{
                    funHideLoader();
                    $('#selactivities_id').empty();
                     $('#seltask_id').empty();
                  }
   }
  });

}else{
  funHideLoader();
      $('#selactivities_id').empty();
       $('#seltask_id').empty();
     }

}
//funtion end

function funEditIntentEntry(id)
{
  var task_id = $("#task_id"+id).val();
  var emp_id = $("#emp_id"+id).val();
  var project_start_date = $("#project_start_date"+id).val();
  var target_date = $("#target_date"+id).val();
  var hour = $("#hour"+id).val();
  var weighter_score = $("#weighter_score"+id).val();
  // console.log('Edit::>>>> ',weighter_score);

  funSetValue("txtEditSno",id);

  funSetValue("selEdittask_id",task_id);
  funSetValue("selEditemp_id",emp_id);
  funSetValue("txtEditproject_start_date",project_start_date);
  funSetValue("txtEdittarget_date",target_date);
  funSetValue("txtEdithour",hour);
  funSetValue("txtWeighterScore",weighter_score);


  funOpenModal("modalEditIntent");
}

function editIntentEntryConfirm()
{
  var id = funGetValue('txtEditSno');

    var result = funGetValueWe('selEdittask_id').split(' - ');
                var task_name = result[1];
    var emp = funGetValueWe('selEditemp_id').split('-');
                var emp_name = emp[1];

  funSetValue('task_id'+id,funGetValueWe('selEdittask_id'));
  funSetValue('emp_id'+id,funGetValueWe('selEditemp_id'));
  funSetValue('project_start_date'+id,funGetValueWe('txtEditproject_start_date'));
  funSetValue('target_date'+id,funGetValueWe('txtEdittarget_date'));
  funSetValue('hour'+id,funGetValueWe('txtEdithour'));
  funSetValue('weighter_score'+id,funGetValueWe('txtWeighterScore'));

  $("#td_task_name"+id).html(task_name);
  $("#td_emp_name"+id).html(emp_name);
  $("#td_project_start_date"+id).html(funGetValueWe('txtEditproject_start_date'));
  $("#td_target_date"+id).html(funGetValueWe('txtEdittarget_date'));
  $("#td_hour"+id).html(funGetValueWe('txtEdithour'));
  $("#td_weighter_score"+id).html(funGetValueWe('txtWeighterScore'));


  funCloseModal("modalEditIntent");
}

function changeWorkItem(id)
{
  funChangeWorkItem(id);
}
/* end assign resource */



/* Start Time sheet */

function addTimeSheetEntry()
{
 var Edithours_taken = parseFloat($("#EditSpantot_hours").html());
  console.log('ff',Edithours_taken);
var Edithours_taken_tot = Edithours_taken;

  var project_id = funGetValueWe("selproject_id");
  var timesheet_date = funGetValueWe("txttimesheet_date");
  var task_id = funGetValueWe("seltask_id");
   var work_item_id = funGetValueWe("selwork_item_id");
   var activities_id = funGetValueWe("selactivities_id");

 // var emp_id = funGetValueWe("hours_taken");

  var hours_taken = funGetValueWe("txthours_taken");
 // var used_emp_id = funGetValueWe("selused_emp_id");
  //var used_emp_hours = funGetValueWe("txtused_emp_hours");
  //var named_emp_id = funGetValueWe("selnamed_emp_id");
  //var named_emp_hours = funGetValueWe("txtnamed_emp_hours");
  //var completion_date = funGetValueWe("txtcompletion_date");
  var comments = funGetValueWe("txtareacomments");

  if(task_id == '' )
  {
    funErrorMessage("Please select task");
  }
  else {

    var result = task_id.split(' - ');
                var task_name = result[1];
  //  var used_emp = used_emp_id.split('-');
    //            var used_emp_name = used_emp[1];
    //var named_emp = named_emp_id.split('-');
      //          var named_emp_name = named_emp[1];
                var project = project_id.split('-');
                var project_name = project[1];
                var work_item = work_item_id.split('-');
                var work_item_name = work_item[1];
                var activities = activities_id.split('-');
                var activities_name = activities[1];
//alert (result);
console.log('up',sno);
     var _template = '<tr id="TimeSheetItem'+sno+'">';
     _template += '<td id="td_timesheet_date'+sno+'">'+timesheet_date+'</td>';
     _template += '<td id="td_project_name'+sno+'">'+project_name+'</td>';
    _template += '<td id="td_workitem_name'+sno+'">'+work_item_name+'</td>';
    _template += '<td id="td_activities_name'+sno+'">'+activities_name+'</td>';
    _template += '<td id="td_task_name'+sno+'">'+task_name+'</td>';
    _template += '<td id="td_hours_taken'+sno+'">'+hours_taken+'</td>';
  //  _template += '<td id="td_used_emp_name'+sno+'">'+used_emp_name+'</td>';
   // _template += '<td id="td_used_emp_hours'+sno+'">'+used_emp_hours+'</td>';
   // _template += '<td id="td_named_emp_name'+sno+'">'+named_emp_name+'</td>';
   // _template += '<td id="td_named_emp_hours'+sno+'">'+named_emp_hours+'</td>';
  //  _template += '<td id="td_completion_date'+sno+'">'+completion_date+'</td>';
    _template += '<td id="td_comments'+sno+'">'+comments+'</td>';

    _template +='<input type="hidden" id="timesheet_date'+sno+'" name="TimeSheetItem['+sno+'][timesheet_date]" value="'+timesheet_date+'" />';
    _template +='<input type="hidden" id="project_id'+sno+'" name="TimeSheetItem['+sno+'][project_id]" value="'+project_id+'" />';
    _template +='<input type="hidden" id="work_item_id'+sno+'" name="TimeSheetItem['+sno+'][work_item_id]" value="'+work_item_id+'" />';
     _template +='<input type="hidden" id="activities_id'+sno+'" name="TimeSheetItem['+sno+'][activities_id]" value="'+activities_id+'" />';
    _template +='<input type="hidden" id="task_id'+sno+'" name="TimeSheetItem['+sno+'][task_id]" value="'+task_id+'" />';
    _template +='<input type="hidden" id="hours_taken'+sno+'" name="TimeSheetItem['+sno+'][hours_taken]" value="'+hours_taken+'" />';
 //   _template +='<input type="hidden" id="used_emp_id'+sno+'" name="TimeSheetItem['+sno+'][used_emp_id]" value="'+used_emp_id+'" />';
 //   _template +='<input type="hidden" id="used_emp_hours'+sno+'" name="TimeSheetItem['+sno+'][used_emp_hours]" value="'+used_emp_hours+'" />';
 //   _template +='<input type="hidden" id="named_emp_id'+sno+'" name="TimeSheetItem['+sno+'][named_emp_id]" value="'+named_emp_id+'" />';
 //   _template +='<input type="hidden" id="named_emp_hours'+sno+'" name="TimeSheetItem['+sno+'][named_emp_hours]" value="'+named_emp_hours+'" />';
 //   _template +='<input type="hidden" id="completion_date'+sno+'" name="TimeSheetItem['+sno+'][completion_date]" value="'+completion_date+'" />';
    _template +='<input type="hidden" id="comments'+sno+'" name="TimeSheetItem['+sno+'][comments]" value="'+comments+'" />';
 // _template += '<td class="width-200px" style="display:inline-block;"><div style="display:inline-block;"><button type="button" onclick="funEditTimeSheetEntry('+sno+')" class="btn btn-primary btn-sm"> <i class="fa fa-edit"> </i> </button>';
    _template += '<td class="width-200px" style="display:inline-block;"><div style="display:inline-block;" ><button type="button" onclick="funRemoveTimeSheetEntry('+sno+')" class="btn btn-danger btn-sm"> <i class="fa fa-close"> </i> </button> </td>';

    $("#tbodyTimeSheetEntries").append(_template);

    clearTimeSheetEntry();
    gotoFocus('selproject_id');
    sno++;
//echo "hai";

  }
  tot_hours += +hours_taken;
//  tot_usedemp_hours += +used_emp_hours;
 // tot_namedemp_hours += +named_emp_hours;

Edithours_taken_tot += +hours_taken;

  $("#Spantot_hours").html(tot_hours);
  $("#EditSpantot_hours").html(Edithours_taken_tot);

  //$("#Spantot_usedemp_hours").html(tot_usedemp_hours);
  //$("#Spantot_namedemp_hours").html(tot_namedemp_hours);

 console.log("in add "+sno);
}




function funRemoveTimeSheetEntry(sno)
{
  var hours_taken = $("#hours_taken"+sno).val();
  var hours_minus = $("#Spantot_hours").text();
  var edit_hours_minus = $("#EditSpantot_hours").text();
  tot_hours = parseInt(hours_minus)-parseInt(hours_taken);
  var tot_hours1 = parseInt(edit_hours_minus)-parseInt(hours_taken);
  $("#Spantot_hours").html(tot_hours);
  $("#EditSpantot_hours").html(tot_hours1);

 /* var Uhours_taken = $("#used_emp_hours"+sno).val();
  var Uhours_minus = $("#Spantot_usedemp_hours").text();
  tot_usedemp_hours = Uhours_minus-Uhours_taken;
  $("#Spantot_usedemp_hours").html(tot_usedemp_hours);

  var Nhours_taken = $("#named_emp_hours"+sno).val();
  var Nhours_minus = $("#Spantot_namedemp_hours").text();
  tot_namedemp_hours = Nhours_minus-Nhours_taken;
  $("#Spantot_namedemp_hours").html(tot_namedemp_hours);
 */



  $("#TimeSheetItem"+sno).remove();
}

function clearTimeSheetEntry()
{
  funSetValue("selproject_id","");
  funSetValue("txttimesheet_date","");
  funSetValue("seltask_id","");
  funSetValue("selwork_item_id","");
  funSetValue("selactivities_id","");
  funSetValue("txthours_taken","");
    funSetValue("txtareacomments","");
}

function funEditTimeSheetEntry(id)
{
   $(".date").datepicker();

  var project_id = $("#project_id"+id).val();
  var timesheet_date = $("#timesheet_date"+id).val();
  var work_item_id = $("#work_item_id"+id).val();
  var task_id = $("#task_id"+id).val();
  var hours_taken = $("#hours_taken"+id).val();
//  var used_emp_id = $("#used_emp_id"+id).val();
 // var used_emp_hours = $("#used_emp_hours"+id).val();
 // var named_emp_id = $("#named_emp_id"+id).val();
 // var named_emp_hours = $("#named_emp_hours"+id).val();
//  var completion_date = $("#completion_date"+id).val();
  var comments = $("#comments"+id).val();

  funSetValue("txtEditSno",id);
  funSetValue("selEditproject_id",project_id);
  funSetValue("selEditwork_item_id",work_item_id);
  funSetValue("txtEdittimesheet_date",timesheet_date);
  funSetValue("selEdittask_id",task_id);
  funSetValue("txtEdithours_taken",hours_taken);
 // funSetValue("selEditused_emp_id",used_emp_id);
 // funSetValue("txtEditused_emp_hours",used_emp_hours);
 // funSetValue("selEditnamed_emp_id",named_emp_id);
  //funSetValue("txtEditnamed_emp_hours",named_emp_hours);
//  funSetValue("txtEditcompletion_date",completion_date);
  funSetValue("txtEditareacomments",comments);
  funOpenModal("modalEditTimeSheet");
}


function editTimeSheetEntryConfirm()
{
  var id = funGetValue('txtEditSno');

    var result = funGetValueWe('selEdittask_id').split(' - ');
                var task_name = result[1];
    var work_item = funGetValueWe('selEditwork_item_id').split('-');
                var work_item_name = work_item[1];
  /*  var named_emp = funGetValueWe('selEditnamed_emp_id').split('-');
                var named_emp_name = named_emp[1];   */
    var project = funGetValueWe('selEditproject_id').split('-');
                var project_name = project[1];


  funSetValue('project_id'+id,funGetValueWe('selEditproject_id'));
  funSetValue('timesheet_date'+id,funGetValueWe('txtEdittimesheet_date'));
  funSetValue('work_item_id'+id,funGetValueWe('selEditwork_item_id'));
  funSetValue('task_id'+id,funGetValueWe('selEdittask_id'));
  funSetValue('hours_taken'+id,funGetValueWe('txtEdithours_taken'));
 // funSetValue('used_emp_id'+id,funGetValueWe('selEditused_emp_id'));
 // funSetValue('used_emp_hours'+id,funGetValueWe('txtEditused_emp_hours'));
 // funSetValue('named_emp_id'+id,funGetValueWe('selEditnamed_emp_id'));
  //funSetValue('named_emp_hours'+id,funGetValueWe('txtEditnamed_emp_hours'));
//  funSetValue('completion_date'+id,funGetValueWe('txtEditcompletion_date'));
  funSetValue('comments'+id,funGetValueWe('txtEditareacomments'));


  $("#td_project_name"+id).html(project_name);
  $("#td_timesheet_date"+id).html(funGetValueWe('txtEdittimesheet_date'));
  $("#td_task_name"+id).html(task_name);
  $("#td_workitem_name"+id).html(work_item_name);
//  $("#td_used_emp_name"+id).html(used_emp_name);
 // $("#td_named_emp_name"+id).html(named_emp_name);
  $("#td_hours_taken"+id).html(funGetValueWe('txtEdithours_taken'));
 // $("#td_used_emp_hours"+id).html(funGetValueWe('txtEditused_emp_hours'));
//  $("#td_named_emp_hours"+id).html(funGetValueWe('txtEditnamed_emp_hours'));
//  $("#td_completion_date"+id).html(funGetValueWe('txtEditcompletion_date'));
  $("#td_comments"+id).html(funGetValueWe('txtEditareacomments'));

  funCloseModal("modalEditTimeSheet");
}

/* End Time sheet */


/* Add Expense Entry Start */

function expenseFile(input) {
  funShowLoader();
  var formData = new FormData();
  formData.append('file', $('#file')[0].files[0]);
  formData.append('_token', funGetToken());
  // console.log(formData);
  $.ajax({
    type: 'POST',
    url: baseURL + adminUrl + '/ajax/expense/image-upload',
    data: formData,
    processData: false, // tell jQuery not to process the data
    contentType: false, // tell jQuery not to set contentType
    success: function(data) {
      funHideLoader();
      // console.log('correct',data);
      if (data.status == true) {
        $('#getFileName').val(data.name);
        // $("td.td_file").html(data.name);
        // $(".td_expense_file").val(data.name);
      } else {
        funHideLoader();
        funErrorMessage("Something went wrong");
      }
    },
    error: function(error) {
      funHideLoader();
      funErrorMessage("Image not uploaded");
      setTimeout(function() {
          // wait for 5 secs(2)
          location.reload(); // then reload the page.(3)
        }, 5000);
      // console.log('wrong---', error);
    }
  });
}

function addExpenseEntry() {
  var expense_date = $('#expense_date').val();
  var project_id = $('#project_id').val();
  var work_item_id = $('#work_item_id').val();
  var expense_activity_id = $('#expense_activity_id').val();
  var approver_id = $('#approver_id').val();
  var expense_type_id = $('#expense_type_id').val();
  var expense_amount = $('#expense_amount').val();
  var expense_file = $('#getFileName').val();
  var primaryApp = $('#txtExpPrimaryApp').val();
  var secondaryApp = $('#txtExpSecondaryApp').val();

  var primaryAppId = $('#txtExpPrimaryAppId').val();
  var secondaryAppId = $('#txtExpSecondaryAppId').val();
  var comments = $('#comments').val();

  // console.log('check', primaryApp,secondaryApp,primaryAppId,secondaryAppId);

  if (expense_date == '') {
    funErrorMessage('Please Select Date');
    } else if(project_id=='') {
        funErrorMessage('Please Select Project');
    } else if(work_item_id=='') {
        funErrorMessage('Please Select Work Item');
    } else if(expense_activity_id=='') {
        funErrorMessage('Please Select Expense Activity');
    } else if(expense_type_id=='') {
        funErrorMessage('Please Select Expense Type');
    } else if(expense_amount=='') {
        funErrorMessage('Please Enter Expense Type');
  }else {
    //splitting id and values
    var project = project_id.split('-');
    var project_name = project[1];

    var work_item = work_item_id.split('-');
    var work_item_name = work_item[1];

    var expense_activity = expense_activity_id.split('-');
    var expense_activity_name = expense_activity[1];

    // var approver = approver_id.split('-');
    // var approver_name = approver[1];

    var expense_type = expense_type_id.split('-');
    var expense_type_name = expense_type[1];

    // console.log(project);
    // console.log(approver);
    // console.log(expense_type);

    // var expense_file = $("#file")[0].files[0].name;
    var expense_file_name = '';
    var file = $('#file').val();
    if (file == undefined || file == '') {
      expense_file_name = '';
    } else {
      var split = file.split('fakepath\\');
      expense_file_name = split[1];
    }

    var _template = '<tr id="ExpenseItem'+sno+'">';
    _template += '<td id="td_expense_date'+sno+'">'+expense_date+'</td>';
    _template += '<td id="td_project_id'+sno+'">'+project_name+'</td>';
    _template += '<td id="td_work_item_id'+sno+'">'+work_item_name+'</td>';
    _template += '<td id="td_work_item_id'+sno+'">'+expense_activity_name+'</td>';
    _template += '<td id="td_approver_id'+sno+'">'+primaryApp+'</td>';
    _template += '<td id="td_sec_approver_id'+sno+'">'+secondaryApp+'</td>';
    _template += '<td id="td_expense_type_id'+sno+'">'+expense_type_name+'</td>';
    _template +='<td id="td_expense_amount'+sno+'" class="expense_amount">'+expense_amount+'</td>';
    _template += '<td id="td_file'+sno+'" class="td_file">'+expense_file_name+'</td>';
    _template += '<td id="td_comments'+sno+'" class="td_comments">'+comments+'</td>';

    //hidden fields
    _template += '<input type="hidden" id="expense_date'+sno+'" name="ExpenseItem['+sno+'][expense_date]" value="'+expense_date+'" />';

    _template += '<input type="hidden" id="project_id'+sno+'" name="ExpenseItem['+sno+'][project_id]" value="'+project_id+'" />';

    _template += '<input type="hidden" id="work_item_id'+sno+'" name="ExpenseItem['+sno+'][work_item_id]" value="'+work_item_id+'" />';

    _template += '<input type="hidden" id="expense_activity_id'+sno+'" name="ExpenseItem['+sno+'][expense_activity_id]" value="'+expense_activity_id+'" />';

     _template += '<input type="hidden" id="approver_id'+sno+'" class="td_approver_id" name="ExpenseItem['+sno+'][approver_id]" value="'+primaryAppId+'" />';

     _template += '<input type="hidden" id="sec_approver_id'+sno+'" class="td_sec_approver_id" name="ExpenseItem['+sno+'][secondary_approver_id]" value="'+secondaryAppId+'" />';

    _template += '<input type="hidden" id="expense_type_id'+sno+'" class="td_expense_type_id" name="ExpenseItem['+sno+'][expense_type_id]" value="'+expense_type_id+'" />';

    _template += '<input type="hidden" id="expense_file'+sno+'" class="td_expense_file" name="ExpenseItem['+sno+'][expense_file]" value="'+expense_file+'" />';

    _template += '<input type="hidden" id="expense_amount'+sno+'" class="td_expense_amount" name="ExpenseItem['+sno+'][expense_amount]" value="'+expense_amount+'" />';

    _template += '<input type="hidden" id="comments'+sno+'" class="td_expense_comments" name="ExpenseItem['+sno+'][comments]" value="'+comments+'" />';

    _template += '<td class="width-200px" style="display:inline-block;"><div style="display:inline-block;"><button type="button" onclick="funRemoveExpenseEntry('+sno+')" class="btn btn-danger btn-sm"><i class="fa fa-close"></i></button> </td>';
    _template += '</tr>';

    // console.log(expense_file);
    $('#tbodyExpenseEntries').append(_template);

    var total_sum = 0;
    $('td.expense_amount').each(function() {
      var tdExpense = $(this).text();
      if ($.isNumeric(tdExpense)) {
        total_sum += parseFloat(tdExpense);
      }
    });
    total_sum = total_sum.toFixed(2);
    // $('#total_expense').html(total_sum);
    $('#total_expense').val(total_sum);
    clearExpenseFields();
    sno++;
  }
}

function clearExpenseFields() {
  $('#expense_date').val('');
  $('#project_id').val('');
  $('#work_item_id').val('');
  $('#expense_activity_id').val('');
  $('#approver_id').val('');
  $('#txtExpPrimaryApp').val('');
  $('#txtExpSecondaryApp').val('');
  $('#approver_id').val('');
  $('#expense_type_id').val('');
  $('#file').val('');
  $('#expense_amount').val('');
  $('#comments').val('');
  $('#getFileName').val('');
}

function funRemoveExpenseEntry(sno) {
  var total_expense = $('#expense_amount' + sno).val();
  var amount_minus = $('#total_expense').val();
  tot_hours = amount_minus - total_expense;
  $('#total_expense').val(tot_hours);
  $('#ExpenseItem' + sno).remove();
}

function getExpenseProject(projectId){
  funShowLoader();
  // console.log(projectId);
   $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/ajax/expense/get-project-owner",
    data: '_token='+funGetToken()+'&project_id='+projectId,
    success: function(response) {
      funHideLoader();
      // console.log(response);
      if(response.status) {
        funSetValue('txtExpPrimaryApp','');
        funSetValue('txtExpSecondaryApp','');

        $('#txtExpPrimaryAppId').focus;
        funSetValue('txtExpPrimaryApp',response.data.priApp.emp_name);
        funSetValue('txtExpPrimaryAppId',response.data.priApp.emp_id);
        // $('#txtSecondaryApp').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+response.data.priApp.emp_name +'</label>');
        $('#txtExpSecondaryAppId').focus;
        if (response.data.secApp != '' || response.data.secApp != null){
          funSetValue('txtExpSecondaryApp',response.data.secApp.emp_name);
          funSetValue('txtExpSecondaryAppId',response.data.secApp.emp_id);
        } else {
          funSetValue('txtExpSecondaryApp','');
          funSetValue('txtExpSecondaryAppId','');
        }
        // $('#approver_id').val(response.data[0].emp_id);
        // $('#approver').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+response.data[0].emp_name +'</label>');
      } else {
        funHideLoader();
        // $('#approver_id').empty();
        // $('#approver').html('');
        funSetValue('txtExpPrimaryApp','');
        funSetValue('txtExpPrimaryAppId','');
        funSetValue('txtExpSecondaryApp','');
        funSetValue('txtExpSecondaryAppId','');
      }
    }
  });
}

function funExpenseSendForApproval(status, id) {
  funShowLoader();
  $.ajax({
    type: 'POST',
    dataType: 'JSON',
    url: baseURL+adminUrl+'/ajax/expense/send-approval',
    data: '_token='+funGetToken()+'&id='+id+'&status='+status,
    success: function(response) {
      funHideLoader();
      if (response.status == true) {
        funSuccessMessage(response.message);
        setTimeout(function() {
          location.reload();
        }, 5000);
      } else {
        funHideLoader();
        funErrorMessage('Something went wrong');
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage('Error occured !!! Please try after sometime.');
    }
  });
}

function funExpenseApproveManager(status, id, comments_mandat = false) {
  comments = funGetValueWe('comments');

  if((comments_mandat) && (!comments)) {
      funErrorMessage('Comment required to reject this claim.');
      return false
  }
  funShowLoader();
  $.ajax({
    type: 'POST',
    url: baseURL + adminUrl + '/ajax/expense/approval',
    data: '_token=' + funGetToken() + '&id=' + id + '&status=' + status + '&comments=' + comments,
    success: function(response) {
      funHideLoader();
      // console.log(response);
      if (response.status == true) {
        $('#butApprove' + id).remove();
        $('#butRejectNeedReview' + id).remove();
        // console.log(response.status_msg);
        // console.log(response.message);
        funSuccessMessage(response.message);
        setTimeout(function() {
          // wait for 5 secs(2)
          location.reload(); // then reload the page.(3)
        }, 5000);
      } else {
        funErrorMessage(response.message);
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage('Error occured !!! Please try after sometime.');
    }
  });
}

/* Add Expense Entry end */


/* Leave Request start */

function getLeaveProject(projectId){
  funShowLoader();
  // console.log(projectId);
   $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/ajax/leave/get-project-owner",
    data: '_token='+funGetToken()+'&project_id='+projectId,
    success: function(response) {
      // console.log(response);
      funHideLoader();
      if(response.status) {
        // funSetValue('txtPrimaryApp','');
        // funSetValue('txtSecondaryApp','');
         $('#txtWorkItem').empty();
         $('#txtWorkItem').append('<option value="">-- Select Workitem --</option>');
        $.each(response.data.workItem, function(key, value){
            $('select[name="work_item_id"]').append('<option value="'+ value.work_item_id +' - '+ value.work_item_name +'">' + value.work_item_name+ '</option>');
         });
        $('#txtPrimaryAppId').focus();
        funSetValue('txtPrimaryApp',response.data.priApp.emp_name);
        funSetValue('txtPrimaryAppId',response.data.priApp.emp_id);
        // $('#txtSecondaryApp').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+response.data.priApp.emp_name +'</label>');
        $('#txtSecondaryAppId').focus();
        funSetValue('txtSecondaryApp',response.data.secApp.emp_name);
        funSetValue('txtSecondaryAppId',response.data.secApp.emp_id);
        // $('#setSecApproverName').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+response.data.priApp.emp_name +'</label>');
      } else {
        funHideLoader();
        $('#txtWorkItem').empty();
        $('#txtWorkItem').append('<option value="">-- Select Workitem --</option>');
        funSetValue('txtPrimaryApp','');
        funSetValue('txtPrimaryAppId','');
        funSetValue('txtSecondaryApp','');
        funSetValue('txtSecondaryAppId','');
      }
    }
  });
}

function funCancelLeaveRequest(status, id)
{
  funShowLoader();
  // console.log(status);
  // console.log(id);
  $.ajax({
    // Ajax call
    type: 'POST',
    url: baseURL + adminUrl + '/ajax/leave/cancel-leave',
    data: '_token='+funGetToken()+'&leave_id='+id+'&status='+status,
    success: function(response) {
      funHideLoader();
      // console.log(response);
      if (response.status == true) {
        funSuccessMessage(response.message);
      } else {
        funHideLoader();
        funErrorMessage(response.message);
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage('Error occured !!! Please try after sometime.');
      // funErrorMessage("Something went wrong");
    }
  });
}

function funLeaveSendForApproval(status, id)
{
  console.log(status);
  console.log(id);
}

/* Leave Request end */

/* filter and download code starts */
function fun_filter_search_submit()
{
  var redirect = funGetValueWe('redirect');
  var query_url = '';
  $(filterSearchArray).each(function(index,value){


      if(funGetValue(value)!='' ){
        // console.log(funGetValue(value));
        query_url = funSetQueryUrlValue(query_url,value,funGetValue(value));
      }

      if(funGetValue(value)==''){
        query_url = funRemoveUrlValue(query_url,value,funGetUrlParameter(value));
      }
      // console.log(query_url);
  });

  if(query_url == '')
    url = funGetValueWe('page_url');
  else
    url = funGetValueWe('page_url')+'?'+query_url;
  url = funUrlValidator(url);
  url = funUrlValidator(url);
  window.location = url;
}

function fun_filter_search_submit_new(e)
{
  var query_url = '';
  $(filterSearchArray).each(function(index,value){

      if(funGetValue(value)!='' ){
        query_url = funSetQueryUrlValue(query_url,value,funGetValue(value));
      }

      if(funGetValue(value)==''){
        query_url = funRemoveUrlValue(query_url,value,funGetUrlParameter(value));
      }
  });

  if(query_url == '')
    url = $(e).attr('data-menu_url');
  else
    url = funGetValueWe('page_url')+'?'+query_url;

  url = funUrlValidator(url);
  window.location = url;
}


function funSetQueryUrlValue(query_url,parameter_name,parameter_value)
{
  // console.log('parameter Value - '+parameter_value);
  if(query_url == '')
      query_url = parameter_name+'='+parameter_value;
    else
      query_url = query_url+'&'+parameter_name+'='+parameter_value;
      
    return query_url;
}

function funUrlValidator(url)
{
  url = url.replace('?&','?');
  url = url.replace('&&','&');
  url = url.replace('&&&','&');
  return url.replace(/&&+$/,'');
}

function funRemoveUrlValue(query_url,name,value)
{
  // console.log(para_value);
  para_value = name+'='+value;
  query_url = query_url.replace(para_value,'');
  query_url = query_url.replace(/&+$/,'');
  return query_url.replace(/&&+$/,'');
}

function funGetUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

function fun_filter_download_submit()
{
  var redirect = funGetTokenWe("redirect");
  // console.log(redirect);
  window.location = baseURL+'deductions/download'+redirect == '' ? '' : redirect;
}

var downloadArray = [];
function funAddToTaskDownload(id)
{
  var index = downloadArray.indexOf(id);
  if(index > -1) {
      downloadArray.splice(index, 1);
  }
  else {
    downloadArray.push(id);
  }
  // funSetValue("txtSelectedDownloadIds",downloadArray.toString());
  var url = funGetValueWe("txtDownloadUrl");
  $("#aDownload").attr("href",url+'?ids='+downloadArray.toString());
}

function funDownloadTask()
{
  var url = funGetValue("txtDownloadUrl");
  var ids = funGetValue("txtSelectedDownloadIds");
}
/* filter and download code end */

function funSendResourceReport()
{
  funShowLoader();
  from_date = funGetValueWe('txtResourceTimeFromdate');
  to_date = funGetValueWe('txtResourceTimeTodate');
  var emp_id = funGetValueWe('txtEmpId');
  // console.log(from_date);
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/reports/resource-hours/send-report",
    data: '_token='+funGetToken()+'&id='+emp_id+'&from_date='+from_date+'&to_date='+to_date,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
         else{
          funHideLoader();
           funErrorMessage(response.message);
        }
    },
    error: function() {
       funHideLoader();
       funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSendTaskUtilizationReport(id)
{
  funShowLoader();
  from_date = funGetValueWe('txtTaskUtilFromDate');
  to_date = funGetValueWe('txtTaskUtilToDate');
  // console.log(from_date);
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/reports/task-hours/send-report",
    data: '_token='+funGetToken()+'&id='+id+'&from_date='+from_date+'&to_date='+to_date,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
        else{
          funHideLoader();
          funErrorMessage(response.message);
        }
    },
    error: function() {
      funHideLoader();
       funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSendLeaveReport(){
  funShowLoader();
  from_date = funGetValueWe('txtLeaveFromDate');
  to_date = funGetValueWe('txtLeaveToDate');
  const emp_id = funGetValueWe('txtEmpId');
  const project_id = funGetValueWe('txtLeaveProjectId');
  const work_item_id = funGetValueWe('txtLeaveWorkItemId');
  // console.log(project_id,work_item_id,emp_id);
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/reports/leave-report/send-report",
    data: '_token='+funGetToken()+'&id='+emp_id+'&from_date='+from_date+'&to_date='+to_date+'&project_id='+project_id+'&work_item_id='+work_item_id,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
        else{
          funHideLoader();
           funErrorMessage(response.message);
        }
    },
    error: function() {
      funHideLoader();
        funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSendEmployeeLeaveReport(){
  funShowLoader();
  from_date = funGetValueWe('txtLeaveFromDate');
  to_date = funGetValueWe('txtLeaveToDate');
  const emp_id = funGetValueWe('txtEmpId');
  $.ajax({
    type: "GET",
    url: baseURL+adminUrl+"/reports/leave-report/send-report",
    data: '_token='+funGetToken()+'&id='+emp_id+'&from_date='+from_date+'&to_date='+to_date,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
        else{
          funHideLoader();
           funErrorMessage(response.message);
        }
    },
    error: function() {
      funHideLoader();
        funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSendExpenseReport(){
  funShowLoader();
  const region_id = funGetValueWe('txtExpenseRegionId');
  const project_id = funGetValueWe('txtExpenseProjectId');
  const emp_id = funGetValueWe('txtEmpId');
  from_date = funGetValueWe('txtExpenseFromDate');
  to_date = funGetValueWe('txtExpenseToDate');
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/reports/expense-report/send-report",
    data: '_token='+funGetToken()+'&id='+emp_id+'&from_date='+from_date+'&to_date='+to_date+'&project_id='+project_id+'&region_id='+region_id,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
        else{
          funHideLoader();
           funErrorMessage(response.message);
        }
    },
    error: function() {
      funHideLoader();
        funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funSendClientExpenseReport(){
  funShowLoader();
  const emp_id = funGetValueWe('txtEmpId');
  from_date = funGetValueWe('txtExpenseFromDate');
  to_date = funGetValueWe('txtExpenseToDate');
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/reports/client-expense-report/send-report",
    data: '_token='+funGetToken()+'&id='+emp_id+'&from_date='+from_date+'&to_date='+to_date,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
        else{
          funHideLoader();
           funErrorMessage(response.message);
        }
    },
    error: function() {
      funHideLoader();
        funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funShowFieldMessage(){
  funErrorMessage('Please select atleast one field to send report');
}
// sathish code leave bal

// Code starts for exclude sat and sun 
function calcLeaveDays(dFrom, dEnd) {

  var start = new Date(dFrom);
  var  end   = new Date(dEnd);
  var exclude = $("#exclude").val();
  if(exclude == 1)
  {
    var loop = new Date(start);
    var calDay = 0;
    while(loop <= end){
      var d = new Date(loop);
      var weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";
      var n = weekday[d.getDay()];
      if(n != "Saturday" && n != "Sunday")
      {
        calDay = calDay + 1;
      }
      var newDate = loop.setDate(loop.getDate() + 1);
      loop = new Date(newDate);
    }
  }
  else
  {
    var  diff  = new Date(end - start);
    var days  = diff/1000/60/60/24;
    var calDay = days+1;
  }
  return calDay;
 }
 // Code ends for exclude sat and sun 

 function funFROMDATE(fDate){

  var toDate = funGetValueWe('toDate');
  $('#number_of_leave').html('');
  if(toDate==''){

  }
   else if(toDate==fDate){


    $("#leave_id").css("display", "");
     $('#number_of_leave').html('');
    $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">1</label>');
      
   }

  else{
     $("#leave_id").css("display", "none");
    // var get_toDate = toDate;
    var date = moment(toDate, 'MM/DD/YYYY');

var get_toDate= date.format('DD-MM-YYYY');
    to = get_toDate.split("-");
    t = new Date(to[2], to[1] - 1, to[0]);



var date2 = moment(fDate, 'MM/DD/YYYY');
    get_fromDate=date2.format('DD-MM-YYYY');
    from =get_fromDate.split("-");
    f = new Date(from[2], from[1] - 1, from[0]);
    let val=calcLeaveDays(f,t);

    let holidayCount = ($('#exclude_holiday').val() == 1) ? excludeHolidayLeave(f,t) : 0;
    val = val - holidayCount;
    // console.log(val);
 $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+val +'</label>');
  }


}

function funTODATE(toDate){
 var from_date = funGetValueWe('fromDate');

 if(new Date(from_date) > new Date(toDate)) {
    funSetValue('toDate', '')
    funErrorMessage('From Date cannot be earlier than the To Date.');
    return
  }


$('#number_of_leave').html('');
if(from_date==''){


}

 else if(toDate==from_date){


    $("#leave_id").css("display", "");
     $('#number_of_leave').html('');
    $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">1</label>');

   }

else{
  $("#leave_id").css("display", "none");

var date = moment(toDate, 'MM/DD/YYYY');
var get_toDate= date.format('DD-MM-YYYY');
    to = get_toDate.split("-");
    t = new Date(to[2], to[1] - 1, to[0]);

var date2 = moment(from_date, 'MM/DD/YYYY');
var get_fromDate= date2.format('DD-MM-YYYY');
    from =get_fromDate.split("-");
    f = new Date(from[2], from[1] - 1, from[0]);
    let val=calcLeaveDays(f,t);

    let holidayCount = ($('#exclude_holiday').val() == 1) ? excludeHolidayLeave(f,t) : 0;
    val = val - holidayCount;
    $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+val +'</label>');
  }

}

function excludeHolidayLeave(fromDate, toDate) {
  let startDate = new Date(fromDate);
  let endDate   = new Date(toDate);
  let holidayString = $("#holiday_days_list").val();
  let holidays = (holidayString) ? holidayString.split(",") : [];

  let holidayCount = 0;
  var loopDate = new Date(startDate);
  while(loopDate <= endDate){
      let leaveDate = moment(loopDate).format('YYYY-MM-DD')
      if(holidays.includes(leaveDate)) {
          holidayCount = ++holidayCount;
      }

      var newDate = loopDate.setDate(loopDate.getDate() + 1);
      loopDate = new Date(newDate);
  }

  return holidayCount;
  
}

function funEmpFROMDATE(fDate){

  var toDate = funGetValueWe('toDate');
  $('#number_of_leave').html('');
  if(toDate==''){

  }
   else if(toDate==fDate){


    $("#leave_id").css("display", "");
     $('#number_of_leave').html('');
    $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">1</label>');
      
   }

  else{
     $("#leave_id").css("display", "none");
    // var get_toDate = toDate;
    var date = moment(toDate, empRegionDateFormate.toUpperCase().replace('YY', 'YYYY'));
    // alert(fDate);
    console.log(fDate);

var get_toDate= date.format('DD-MM-YYYY');
    to = get_toDate.split("-");
    t = new Date(to[2], to[1] - 1, to[0]);


var date2 = moment(fDate, empRegionDateFormate.toUpperCase().replace('YY', 'YYYY'));
    get_fromDate=date2.format('DD-MM-YYYY');
    from =get_fromDate.split("-");
    f = new Date(from[2], from[1] - 1, from[0]);
    let val=calcLeaveDays(f,t);
    // console.log(val);
 $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+val +'</label>');
  }


}

function funEmpTODATE(toDate){
 var from_date = funGetValueWe('fromDate');

$('#number_of_leave').html('');
if(from_date==''){


}

 else if(toDate==from_date){


    $("#leave_id").css("display", "");
     $('#number_of_leave').html('');
    $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">1</label>');

   }

else{
  $("#leave_id").css("display", "none");

var date = moment(toDate, empRegionDateFormate.toUpperCase().replace('YY', 'YYYY'));
var get_toDate= date.format('DD-MM-YYYY');
    to = get_toDate.split("-");
    t = new Date(to[2], to[1] - 1, to[0]);


var date2 = moment(from_date, empRegionDateFormate.toUpperCase().replace('YY', 'YYYY'));
var get_fromDate= date2.format('DD-MM-YYYY');
    from =get_fromDate.split("-");
    f = new Date(from[2], from[1] - 1, from[0]);
    let val=calcLeaveDays(f,t);
    $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">'+val +'</label>');
  }

}

function funSendTimesheetReport(){

  funShowLoader();

  from_date = funGetValueWe('timesheetFromdate');
  to_date = funGetValueWe('timesheetTodate');
  var emp_id = funGetValueWe('timesheetEmpId');
  var project_id = funGetValueWe('timesheetProjectId');
  var work_item_id = funGetValueWe('timesheetWorkitemId');
  // console.log(from_date);
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/reports/timesheet-report/send-report",
    data: '_token='+funGetToken()+'&id='+emp_id+'&from_date='+from_date+'&to_date='+to_date+'&project_id='+project_id+'&work_item_id='+work_item_id,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
        else{
          funHideLoader();
          funErrorMessage(response.message);
        }
    },
    error: function() {
    funHideLoader();
     funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });

}

function funSendBookHoursReport(){

  funShowLoader();

  let from_date = funGetValueWe('timesheetFromdate');
  let to_date = funGetValueWe('timesheetTodate');
  let emp_id = funGetValueWe('timesheetEmpId');

  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/reports/book-hours-report/send-report",
    data: '_token='+funGetToken()+'&id='+emp_id+'&from_date='+from_date+'&to_date='+to_date,
    success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
        }
        else{
          funHideLoader();
          funErrorMessage(response.message);
        }
    },
    error: function() {
    funHideLoader();
     funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });

}


function funHalfDayLeave(){

  if($('#halfday_leave:checkbox:checked').val()=='on'){
    $('#number_of_leave').html('');

      $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">0.5</label>');
  }
  else{
    $('#number_of_leave').html('');
    $('#number_of_leave').append('<label class="col-form-label" style="border-bottom: 1px solid #ddd;width: 100%">1</label>');
  }


}
// sathish code leave end

function funGetCompany(id){
  // console.log(id);
  funShowLoader();
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/ajax/get-company",
    data: '_token='+funGetToken()+'&group_id='+id,
    success: function(response) {
        funHideLoader();
        if (response) {
          $('#setCompanyId').empty();
          $('#setCompanyId').focus;

          $('#setCompanyId').append('<option>-- Select Company --</option>');
          $.each(response, function(key, value) {
            $('#setCompanyId').append('<option value="'+value.company_id+'">'+value.company_name+'</option>');
          });
        } else {
          funHideLoader();
          $('#setCompanyId').empty();
        }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
    }
  });
}

/*ASSIGN RESOURCE TESTING STARTS*/
function funGetAjaxWorkItem(id){
  funShowLoader();
  if (id) {
    $.ajax({                // Ajax call
      type: "GET",
      url: baseURL+adminUrl+"/project/assign-employee/get-workitem",
      data: '_token='+funGetToken()+'&project_id='+id,
      beforeSend: function(){ funShowLoader(); },
      success: function(response) {
        if(response) {
          $('#work_item').empty();
          $('#selemp_id').empty();
          $('#activities_id').empty();
          $('#work_item').focus;

          $('#work_item').append('<option value="">-- Select Workitem --</option>');
          $.each(response.workItem, function(key, value){
            $('select[name="work_item_id"]').append('<option value="'+ value.work_item_id +'">' + value.work_item_name+ '</option>');
          });
          $('#selemp_id').focus;
          $('#selemp_id').append('<option value="">-- Select Resources --</option>');
          $.each(response.resources, function(key,value){
            $('select[name="emp_id"]').append('<option value="'+value.emp_id+' - '+value.emp_name+'">' + value.emp_name+ '</option>');
          });
          $('#activities_id').append('<option value="">-- Select Activity --</option>');
          $('#showtabledetails tbody').empty();
          $("#assignResourceEntries").empty();
          $("#activity-stats-card").hide();
        } else {
          $('#work_item').empty();
          $('#activities_id').empty();
        }
     },
     error: function(){
      funHideLoader();
      funErrorMessage('Something went worng');
     },
     complete: function(){ funHideLoader(); },
    });

  }else{
    funHideLoader();
    $('#work_item').empty();
    $('#activities_id').empty();
  }

}

function funGetAjaxActivitiesList(id) {
  console.log("Testng", funGetValueWe('activities_id'))
  funShowLoader();
  if (id) {
    var projectId = funGetValueWe('project_id');
    var menuUrl = funGetValueWe('txtMenuUrl');
    var result = id.split(' - ');
    var work_item_id = result[0];
    $.ajax({                // Ajax call
      type: "GET",
      url: baseURL+adminUrl+"/project/assign-employee/get-activities-list",
      data: '_token='+funGetToken()+'&work_item_id='+work_item_id,
      success: function(response) {
        funHideLoader();
        if(response) {
          $('#activities_id').empty();
          $('#activities_id').append('<option value="">-- Select Activity --</option>');
          $('#showtabledetails tbody').empty();
          $("#assignResourceEntries").empty();
          $("#activity-stats-card").hide();
          console.log(response);
          $.each(response, function(key, value){
              console.log(value.activities_id, value.activities_name)
            $('select[name="activities_id"]').append('<option value="'+ value.activities_id +'">' + value.activities_name+ '</option>');
          });
         
         //  $('#activities_id').focus();

        } else {
          $('#activities_id').empty();
          $('#selemp_id').empty();
          $('#showtabledetails tbody').empty();
          $("#assignResourceEntries").empty();
          $("#activity-stats-card").hide();
          funHideLoader();
        
          // $('#selemp_id').focus;
          // $('#selemp_id').append('<option value="">-- Select Resources --</option>');
          // $.each(response.resources, function(key,value){
          //   $('select[name="emp_id"]').append('<option value="'+value.emp_id+' - '+value.emp_name+'">' + value.emp_name+ '</option>');
          // });
        }
      }
    })
  }
}

//Get Activities
function funGetAjaxActivities(id){
  funShowLoader();
  if (id) {
    var projectId = funGetValueWe('project_id');
    var workItemId = funGetValueWe('work_item');
    var menuUrl = funGetValueWe('txtMenuUrl');
    var result = id.split(' - ');
    var work_item_id = result[0];
    $.ajax({                // Ajax call
      type: "GET",
      url: baseURL+adminUrl+"/project/assign-employee/get-activities",
      data: '_token='+funGetToken()+'&work_item_id='+work_item_id,
      success: function(response) {
        funHideLoader();
        if(response) {
          window.location.href = baseURL+adminUrl+'/project/assign-employee/create?project_id='+projectId+'&work_item_id='+workItemId+'&activities_id='+id
         //   $('#showtabledetails').empty();
            // $('#tbodyviewEntries').empty();
            // $('#assignResourceEntries').empty();
            // $('#showtabledetails').focus;
            // $('#showtabledetails').append('');
            // // $('#seltask_id').empty();

            // var _template = '';
            // var _template1_ = '';
            // $.each(response, function(key, value){

            //   _template += '<tr>';
            //   _template += '<td>'+value.activities_name+'</td>';
            //   _template += '<td>'+value.task_name+'</td>';
            //   _template += '<td>'+value.emp_name+'</td>';
            //   _template += '<td>'+value.start_date+'</td>';
            //   _template += '<td>'+value.target_date+'</td>';
            //   _template += '<td>'+(value.hour == null ? 0 : value.hour)+'</td>';
            //   _template += '<td>'+value.weighter_score+'</td>';
            //   _template += '</tr>';
            // });
            // $('#tbodyviewEntries').append(_template);

            // $.each(response, function(key,value){
            //   _template1_ += '<tr>';
            //   _template1_ += '<td><input type="text" class="form-control stop-enter" placeholder="Enter Activities" id="tdActivitiesName'+key+'" name="activities_name" value="'+value.activities_name+'" readonly></td>';

            //   _template1_ += '<td><select name="task_id" id="txtTaskNameId"><option value="">--Select Task --</option><option value="'+value+'"></option></select></td>';

            //   //Hidden Fields
            //    _template1_ += '<input type="hidden" id="txtActivitiesId'+key+'" name="intentItem['+key+'][activities_id]" value="'+value.activities_id+'">';
            //   _template1_ += '</tr>';
            // });

            // $('#assignResourceEntries').append(_template1_);

            } else {
              funHideLoader();
              $('#activities_id').empty();
            }
      }
    });

  }else{
    funHideLoader();
    $('#activities_id').empty();
  }

}
/*ASSIGN RESOURCE TESTING STARTS ENDS*/

function funGetClientProject(id){
  if (id) {
    funShowLoader();
    $.ajax({                // Ajax call
      type: "GET",
      url: baseURL+adminUrl+"/ajax/get-client-project",
      data: '_token='+funGetToken()+'&client_id='+id,
      success: function(response) {
        funHideLoader();
      if(response) {
          $('#filter_project_id').empty();
          $('#filter_project_id').focus;
          $('#filter_project_id').append('<option value="">-- Select Project --</option>');
          $.each(response, function(key, value){
          $('select[name="filter_project_id"]').append('<option value="'+ value.project_id +'">' + value.project_name+'</option>');
          });
        } else {
          funHideLoader();
          $('#filter_project_id').empty();
        }
      }
     });
    } else {
      funHideLoader();
      $('#filter_project_id').empty();
    }
  }

  function funGetDepartment(id){

  var company_id = $("#company").val();
  var department_values = $('#department').val();
  if ($("#company").val().length > 0) {
    $.ajax({                // Ajax call
      type: "get",
      url: baseURL + adminUrl + "/ajax/get-department",
      data: '_token=' + funGetToken() + '&company_id=' + company_id,
      success: function (response) {
        // console.log(response);
        if (response) {
          $('#department').empty();
          $('#department').focus;
          $('#department').append('<option value="">-- Select Department --</option>');
          $.each(response.company, function (key, value) {
            $('#department').append('<optgroup label="' + value.company_name + '">');
            $.each(value.departments, function (key, list) {
              $option = $('<option value="' + list.dep_id + '">' + list.dep_name + '</option>');
              if (department_values.includes(list.dep_id.toString())) {
                $option.attr('selected', 'selected');
              }
              $('#department').append($option);
            });
            $('#department').append('</optgroup>');
          });

        }
        else {
          $('#department').empty();
        }
      }
    });
  }
  else {
    $('#department').empty();
  }
}

function funGetEditDepartment(id) {
  var company_id = $("#company").val();
  var department_values = $('#department').val();

  if ($("#company").val().length > 0) {
    $.ajax({                // Ajax call
      type: "get",
      url: baseURL + adminUrl + "/ajax/get-department",
      data: '_token=' + funGetToken() + '&company_id=' + company_id,
      success: function (response) {

        if(response) {
          $('#department').empty();
          $('#department').focus;
          $.each(response.company, function (key, value) {
            $('#department').append('<optgroup label="' + value.company_name + '">');
            $.each(value.departments, function (key, list) {
              $option = $('<option value="' + list.dep_id + '" >' + list.dep_name + '</option>');
              if (department_values.includes(list.dep_id.toString())) {
                $option.attr('selected', 'selected');
              }
              $('#department').append($option);
            });
            $('#department').append('</optgroup>');
          });

        }
        else {
          $('#department').empty();
        }
      }
    });
  }
  else {
    $('#department').empty();
  }

}


function funGetAjaxPreviousWeek(date){
  if (date) {
     var menuUrl = funGetValueWe('txtMenuUrl');
     console.log(date);

     var d = new Date(date);
     var n = d.getTimezoneOffset();
     var firstdate = new Date(d.getTime() + n * 60 * 1000);
      var getDate = firstdate.setDate(firstdate.getDate() - 7 );
      var urlDate  = new Date(getDate),
         month = '' + (urlDate.getMonth() + 1),
         day = '' + urlDate.getDate(),
         year = urlDate.getFullYear();

     if (month.length < 2) month = '0' + month;
     if (day.length < 2) day = '0' + day;

     var passUrl =  [year, month, day].join('-');
      console.log(passUrl);
    $.ajax({
      type: "GET",
      success: function(response) {
        if(!response) {
                      window.location.href = baseURL+adminUrl+'/project/booking-hours/create?cur_date='+btoa(passUrl);
                      }
        else
        {
         window.location.href = baseURL+adminUrl+'/project/booking-hours/create?cur_date='+btoa(passUrl);
      }
    }
    });
}
}

function funGetAjaxNextWeek(date){
  if (date) {
     var menuUrl = funGetValueWe('txtMenuUrl');
     console.log(date);

     var firstdate = new Date(date);
      firstdate.setDate(firstdate.getDate() + 7 );
      console.log(firstdate.toISOString().split('T')[0]);
    $.ajax({                // Ajax call
      type: "GET",
      success: function(response) {
        if(!response) {
                      window.location.href = baseURL+adminUrl+'/project/booking-hours/create?cur_date='+btoa(firstdate.toISOString().split('T')[0]);
                      }
        else
        {
         window.location.href = baseURL+adminUrl+'/project/booking-hours/create?cur_date='+btoa(firstdate.toISOString().split('T')[0]);
      }
    }
    });
}
}


/* Start Time sheet */

function addTimeCardEntry()
{

  var project_id = funGetValueWe("selproject_id");
  var timesheet_date = funGetValueWe("txttimesheet_date");
  var task_id = funGetValueWe("seltask_id");
  var work_item_id = funGetValueWe("selwork_item_id");
  var activities_id = funGetValueWe("selactivities_id");
  var hours_taken = funGetValueWe("txthours_taken");
  var comments = funGetValueWe("txtareacomments");
  var billable_type = funGetValueWe("billing_type_id");

  var sunday = funGetValueWe("txtsunday");
  var monday = funGetValueWe("txtmonday");
  var tuesday = funGetValueWe("txttuesday");
  var wednesday = funGetValueWe("txtwednesday");
  var thursday = funGetValueWe("txtthursday");
  var friday = funGetValueWe("txtfriday");
  var saturday = funGetValueWe("txtsaturday");
  var weektotal = funGetValueWe("txtweektotal");

  var sunday_date =funGetValueWe('sunday_date');
  var monday_date =funGetValueWe('monday_date');
  var tuesday_date =funGetValueWe('tuesday_date');
  var wednesday_date =funGetValueWe('wednesday_date');
  var thursday_date =funGetValueWe('thursday_date');
  var friday_date =funGetValueWe('friday_date');
  var saturday_date =funGetValueWe('saturday_date');
  var sundayvalid=0;
  var mondayvalid=0;
  var tuesdayvalid=0;
  var wednesdayvalid=0;
  var thursdayvalid=0;
  var fridayvalid=0;
  var saturdayvalid=0;
  var i;
  var allotted_hours = $('#tdalloted').text()
  var consumed_hours = $('#tdconsumed').text()
  var available_hours = $('#tdavailable').text()

   $('input[name^="sundayTest"]').each(function() {

      $value = $(this).val()==''? 0 : $(this).val();
       sundayvalid += parseFloat($value);
  });
   $('input[name^="mondayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       mondayvalid += $value;
  });
    $('input[name^="tuesdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       tuesdayvalid += $value;
  });
     $('input[name^="wednesdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       wednesdayvalid += $value;
  });
        $('input[name^="thursdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       thursdayvalid += $value;
  });
      $('input[name^="fridayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       fridayvalid += $value;
  });
       $('input[name^="saturdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       saturdayvalid += $value;
  });
  if(project_id == '' )
  {
    funErrorMessage("Please select project");
  }
  else if(work_item_id == '' )
  {
    funErrorMessage("Please select work item");
  }
  else if(activities_id == '' )
  {
    funErrorMessage("Please select activities");
  }
  else if(task_id == '' )
  {
    funErrorMessage("Please select task");
  }
  else if(billable_type == '' )
  {
    funErrorMessage("Please select billable type");
  }

  else if(parseFloat(sunday)+sundayvalid >24){
  funErrorMessage("Sunday work duration is exceed of 24 Hours");
  }
  else if(parseFloat(monday)+mondayvalid >24){
    funErrorMessage("Monday work duration is exceed of 24 Hours");
  }
  else if(parseFloat(tuesday)+tuesdayvalid >24){
    funErrorMessage("Tuesday work duration is exceed of 24 Hours");
  }
  else if(parseFloat(wednesday)+wednesdayvalid >24){
    funErrorMessage("Wednesday work duration is exceed of 24 Hours");
  }
  else if(parseFloat(thursday)+thursdayvalid >24){
    funErrorMessage("Thursday work duration is exceed of 24 Hours");
  }
  else if(parseFloat(friday)+fridayvalid >24){
    funErrorMessage("Friday work duration is exceed of 24 Hours");
  }
  else if(parseFloat(saturday)+saturdayvalid >24){
    funErrorMessage("SaturDay work duration is exceed of 24 Hours");
  }

  else {

    var result = task_id.split(' - ');
                var task_name = result[1];

                var project = project_id.split(' - ');
                var project_name = project[1];
                var work_item = work_item_id.split(' - ');
                var work_item_name = work_item[1];
                var activities = activities_id.split(' - ');
                var activities_name = activities[1];
                // console.log('billable_type',billable_type);
                 var billable_type_name = billable_type.split(' - ');
                var billable_name= billable_type==''?'':billable_type_name[1]
             var mondaycolor=$('#idmonday').css("background-color");
          var tuesdaycolor=$('#idtuesday').css("background-color");
          var wednesdaycolor=$('#idwednesday').css("background-color");
          var thursdaycolor=$('#idthursday').css("background-color");
          var fridaycolor=$('#idfriday').css("background-color");

      var _template = '<tr id="TimeSheetItem'+sno+'">';
     // _template += '<td id="td_timesheet_date'+sno+'">'+timesheet_date+'</td>';
     _template += '<td id="td_project_name'+sno+'">'+project_name+'</td>';
    _template += '<td id="td_workitem_name'+sno+'">'+work_item_name+'</td>';
    _template += '<td id="td_activities_name'+sno+'">'+activities_name+'</td>';
    _template += '<td id="td_task_name'+sno+'">'+task_name+'</td>';
    _template += '<td id="td_type'+sno+'">'+billable_name+'</td>';
     _template += '<td id="td_allotted'+sno+'">'+allotted_hours+'</td>';
      _template += '<td id="td_consumed'+sno+'">'+consumed_hours+'</td>';
       _template += '<td id="td_available'+sno+'">'+available_hours+'</td>';
    // _template += '<td id="td_hours_taken'+sno+'">'+hours_taken+'</td>';
  _template += '<td id="td_sunday'+sno+'" style="background-color: #ddd">'+sunday+'</td>';
   _template += '<td id="td_monday'+sno+'" style="background-color:'+mondaycolor+'">'+monday+'</td>';
   _template += '<td id="td_tuesday'+sno+'" style="background-color:'+tuesdaycolor+'">'+tuesday+'</td>';
   _template += '<td id="td_wednesday'+sno+'" style="background-color:'+wednesdaycolor+'">'+wednesday+'</td>';
   _template += '<td id="td_thursday'+sno+'"  style="background-color:'+thursdaycolor+'">'+thursday+'</td>';
    _template += '<td id="td_friday'+sno+'" style="background-color:'+fridaycolor+'">'+friday+'</td>';
     _template += '<td id="td_saturday'+sno+'" style="background-color: #ddd">'+saturday+'</td>';
     _template += '<td id="td_hours_taken'+sno+'">'+weektotal+'</td>';
    _template += '<td id="td_comments'+sno+'" class="tooltip1"><span class="badge align-self-center ml-auto" id="td_sundaycomments'+sno+'" onclick="funCommentTimeCardEntry('+sno+')" style="background-color: #ddd;padding: 4px 4px;font-size: 12px;border-radius: 50%;cursor:pointer">S</span> <span class="badge align-self-center ml-auto" onclick="funCommentTimeCardEntry('+sno+')" id="td_mondaycomments'+sno+'"style="background-color: #ddd;padding: 4px 4px;font-size: 12px;border-radius: 50%;cursor:pointer">M</span> <span class="badge align-self-center ml-auto" onclick="funCommentTimeCardEntry('+sno+')" id="td_tuesdaycomments'+sno+'"style="background-color: #ddd;padding: 4px 4px;font-size: 12px;border-radius: 50%;cursor:pointer">T</span> <span class="badge align-self-center ml-auto" id="td_wednesdaycomments'+sno+'" onclick="funCommentTimeCardEntry('+sno+')" style="background-color: #ddd;padding: 4px 4px;font-size: 12px;border-radius: 50%;cursor:pointer">W</span> <span class="badge align-self-center ml-auto" id="td_thursdaycomments'+sno+'" onclick="funCommentTimeCardEntry('+sno+')" style="background-color: #ddd;padding: 4px 4px;font-size: 12px;border-radius: 50%;cursor:pointer">T</span> <span class="badge align-self-center ml-auto" id="td_fridaycomments'+sno+'" onclick="funCommentTimeCardEntry('+sno+')" style="background-color: #ddd;padding: 4px 4px;font-size: 12px;border-radius: 50%;cursor:pointer">F</span> <span class="badge align-self-center ml-auto" id="td_saturdaycomments'+sno+'" onclick="funCommentTimeCardEntry('+sno+')" style="background-color: #ddd;padding: 4px 4px;font-size: 12px;border-radius: 50%;cursor:pointer">S</span><span class="tooltiptext1">Add Comments</span></td>';

    // _template +='<input type="hidden" id="timesheet_date'+sno+'" name="TimeSheetItem['+sno+'][timesheet_date]" value="'+timesheet_date+'" />';
    _template +='<input type="hidden" id="project_id'+sno+'" name="TimeSheetItem['+sno+'][project_id]" value="'+project_id+'" />';
    _template +='<input type="hidden" id="work_item_id'+sno+'" name="TimeSheetItem['+sno+'][work_item_id]" value="'+work_item_id+'" />';
     _template +='<input type="hidden" id="activities_id'+sno+'" name="TimeSheetItem['+sno+'][activities_id]" value="'+activities_id+'" />';
    _template +='<input type="hidden" id="task_id'+sno+'" name="TimeSheetItem['+sno+'][task_id]" value="'+result[0]+'" />';
    _template +='<input type="hidden" id="billable_type'+sno+'" name="TimeSheetItem['+sno+'][billable_type]" value="'+billable_type+'" />';
    // _template +='<input type="hidden" id="hours_taken'+sno+'" name="TimeSheetItem['+sno+'][hours_taken]" value="'+hours_taken+'" />';
   _template +='<input type="hidden" id="sunday'+sno+'" name="TimeSheetItem['+sno+'][sunday]" value="'+sunday+'" />';
   _template +='<input type="hidden" id="sundayTest'+sno+'" name="sundayTest['+sno+']" value="'+sunday+'" />';
   _template +='<input type="hidden" id="monday'+sno+'" name="TimeSheetItem['+sno+'][monday]" value="'+monday+'" />';
    _template +='<input type="hidden" id="mondayTest'+sno+'" name="mondayTest['+sno+']" value="'+monday+'" />';
   _template +='<input type="hidden" id="tuesday'+sno+'" name="TimeSheetItem['+sno+'][tuesday]" value="'+tuesday+'" />';
    _template +='<input type="hidden" id="tuesdayTest'+sno+'" name="tuesdayTest['+sno+']" value="'+tuesday+'" />';
   _template +='<input type="hidden" id="wednesday'+sno+'" name="TimeSheetItem['+sno+'][wednesday]" value="'+wednesday+'" />';
   _template +='<input type="hidden" id="wednesdayTest'+sno+'" name="wednesdayTest['+sno+']" value="'+wednesday+'" />';
   _template +='<input type="hidden" id="thursday'+sno+'" name="TimeSheetItem['+sno+'][thursday]" value="'+thursday+'" />';
   _template +='<input type="hidden" id="thursdayTest'+sno+'" name="thursdayTest['+sno+']" value="'+thursday+'" />';
   _template +='<input type="hidden" id="friday'+sno+'" name="TimeSheetItem['+sno+'][friday]" value="'+friday+'" />';
   _template +='<input type="hidden" id="fridayTest'+sno+'" name="fridayTest['+sno+']" value="'+friday+'" />';
   _template +='<input type="hidden" id="saturday'+sno+'" name="TimeSheetItem['+sno+'][saturday]" value="'+saturday+'" />';
   _template +='<input type="hidden" id="saturdayTest'+sno+'" name="saturdayTest['+sno+']" value="'+saturday+'" />';
   _template +='<input type="hidden" id="weektotal'+sno+'" name="TimeSheetItem['+sno+'][weektotal]" value="'+weektotal+'" />';
   _template +='<input type="hidden" id="weektotalTest'+sno+'" name="weektotalTest['+sno+']" value="'+weektotal+'" />';
    _template +='<input type="hidden" id="comments'+sno+'" name="TimeSheetItem['+sno+'][comments]" value="'+comments+'" />';
     _template +='<input type="hidden" id="sunday_date['+sno+']" name="TimeSheetItem['+sno+'][sunday_date]" value="'+sunday_date+'" />';
    _template +='<input type="hidden" id="monday_date'+sno+'" name="TimeSheetItem['+sno+'][monday_date]" value="'+monday_date+'" />';
    _template +='<input type="hidden" id="tuesday_date'+sno+'" name="TimeSheetItem['+sno+'][tuesday_date]" value="'+tuesday_date+'" />';
    _template +='<input type="hidden" id="wednesday_date'+sno+'" name="TimeSheetItem['+sno+'][wednesday_date]" value="'+wednesday_date+'" />';
    _template +='<input type="hidden" id="thursday_date'+sno+'" name="TimeSheetItem['+sno+'][thursday_date]" value="'+thursday_date+'" />';
    _template +='<input type="hidden" id="friday_date'+sno+'" name="TimeSheetItem['+sno+'][friday_date]" value="'+friday_date+'" />';
    _template +='<input type="hidden" id="saturday_date'+sno+'" name="TimeSheetItem['+sno+'][saturday_date]" value="'+saturday_date+'" />';
    _template +='<input type="hidden" id="sunday_comment'+sno+'" name="TimeSheetItem['+sno+'][sunday_comment]"  />';
    _template +='<input type="hidden" id="monday_comment'+sno+'" name="TimeSheetItem['+sno+'][monday_comment]"  />';
    _template +='<input type="hidden" id="tuesday_comment'+sno+'" name="TimeSheetItem['+sno+'][tuesday_comment]"  />';
    _template +='<input type="hidden" id="wednesday_comment'+sno+'" name="TimeSheetItem['+sno+'][wednesday_comment]"  />';
    _template +='<input type="hidden" id="thursday_comment'+sno+'" name="TimeSheetItem['+sno+'][thursday_comment]"  />';
    _template +='<input type="hidden" id="friday_comment'+sno+'" name="TimeSheetItem['+sno+'][friday_comment]"  />';
    _template +='<input type="hidden" id="saturday_comment'+sno+'" name="TimeSheetItem['+sno+'][saturday_comment]"  />';
    for(i=1; i<=10; i++){
    _template +='<input type="hidden" id="sunday_hours_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][sunday_hours]['+i+']"  />';
    _template +='<input type="hidden" id="monday_hours_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][monday_hours]['+i+']"  />';
    _template +='<input type="hidden" id="tuesday_hours_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][tuesday_hours]['+i+']"  />';
    _template +='<input type="hidden" id="wednesday_hours_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][wednesday_hours]['+i+']"  />';
    _template +='<input type="hidden" id="thursday_hours_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][thursday_hours]['+i+']"  />';
    _template +='<input type="hidden" id="friday_hours_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][friday_hours]['+i+']"  />';
    _template +='<input type="hidden" id="saturday_hours_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][saturday_hours]['+i+']"  />';
    _template +='<input type="hidden" id="sunday_reff_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][sunday_reff]['+i+']"  />';
    _template +='<input type="hidden" id="monday_reff_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][monday_reff]['+i+']"  />';
    _template +='<input type="hidden" id="tuesday_reff_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][tuesday_reff]['+i+']"  />';
    _template +='<input type="hidden" id="wednesday_reff_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][wednesday_reff]['+i+']"  />';
    _template +='<input type="hidden" id="thursday_reff_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][thursday_reff]['+i+']"  />';
    _template +='<input type="hidden" id="friday_reff_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][friday_reff]['+i+']"  />';
    _template +='<input type="hidden" id="saturday_reff_'+sno+'_'+i+'" name="TimeSheetItem['+sno+'][saturday_reff]['+i+']"  />';
    }
 _template += '<td class="width-200px"  style="display:flex;"><div style="display:inline-block;"><button type="button" onclick="funEditTimeCardEntry('+sno+')" class="btn btn-primary btn-sm"> <i class="fa fa-edit"> </i> </button>';
    _template += '<div style="display:inline-block;margin-left: 10px;" ><button type="button" onclick="funRemoveTimeSheetEntry('+sno+')" class="btn btn-danger btn-sm"> <i class="fa fa-close"> </i> </button>';

    $("#tbodyTimeSheetEntries").append(_template);
    clearTimeCardEntry();
    gotoFocus('selproject_id');
    var weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    weekdays.forEach(day => {
      if($("#tdtable"+day).css("background-color") == "rgb(244, 67, 54)")
      {
        $('#td_'+day+'comments'+sno).css("background-color", "rgb(244, 67, 54)");
      }
    });
    sno++;

  }
  tot_hours += +hours_taken;
  Edithours_taken_tot += +hours_taken;

  $("#Spantot_hours").html(tot_hours);
  $("#EditSpantot_hours").html(Edithours_taken_tot);

  var sundaycal=0;
  var mondaycal=0;
  var tuesdaycal=0;
  var wednesdaycal=0;
  var thursdaycal=0;
  var fridaycal=0;
  var saturdaycal=0;
  var weektotalcal=0;


  $('input[name^="sundayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       sundaycal += $value;
});
   $('input[name^="mondayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       mondaycal += $value;
});
    $('input[name^="tuesdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       tuesdaycal += $value;
});
     $('input[name^="wednesdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       wednesdaycal += $value;
});
        $('input[name^="thursdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       thursdaycal += $value;
});
      $('input[name^="fridayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       fridaycal += $value;
});
       $('input[name^="saturdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       saturdaycal += $value;
});

       $('input[name^="weektotalTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       weektotalcal += $value;
});
$("#tdsundaytotal").html(sundaycal);
$("#tdmondaytotal").html(mondaycal);
$("#tdtuesdaytotal").html(tuesdaycal);
$("#tdwednesdaytotal").html(wednesdaycal);
$("#tdthursdaytotal").html(thursdaycal);
$("#tdfridaytotal").html(fridaycal);
$("#tdsaturdaytotal").html(saturdaycal);
$("#tdtotalall").html(weektotalcal);
$("#Spantot_hours").html(weektotalcal);

}




function funRemoveTimeCardEntry(sno)
{
  var hours_taken = $("#hours_taken"+sno).val();
  var hours_minus = $("#Spantot_hours").text();
  var edit_hours_minus = $("#EditSpantot_hours").text();
  tot_hours = parseInt(hours_minus)-parseInt(hours_taken);
  var tot_hours1 = parseInt(edit_hours_minus)-parseInt(hours_taken);
  $("#Spantot_hours").html(tot_hours);
  $("#EditSpantot_hours").html(tot_hours1);
  $("#TimeSheetItem"+sno).remove();
}

function clearTimeCardEntry()
{
  funSetValue("selproject_id","");
  funSetValue("txttimesheet_date","");
  funSetValue("seltask_id","");
  funSetValue("selwork_item_id","");
  funSetValue("selactivities_id","");
  funSetValue("txthours_taken","");
  funSetValue("txtareacomments","");
  funSetValue("billing_type_id","");
  funSetValue("txtsunday","");
  funSetValue("txtmonday","");
  funSetValue("txttuesday","");
  funSetValue("txtwednesday","");
  funSetValue("txtthursday","");
  funSetValue("txtfriday","");
  funSetValue("txtsaturday","");
  funSetValue("txtweektotal","");
  $('#tdalloted').text(0.00)
  $('#tdconsumed').text(0.00)
  $('#tdavailable').text(0.00)


}



/* End Time sheet */

function getweektotal(val)
{

 // $('#tdsundaytotal').text("");

  funSetValue("txtweektotal",'');
  var sunday = funGetValueWe("txtsunday");
  var monday = funGetValueWe("txtmonday");
  var tuesday = funGetValueWe("txttuesday");
  var wednesday = funGetValueWe("txtwednesday");
  var thursday = funGetValueWe("txtthursday");
  var friday = funGetValueWe("txtfriday");
  var saturday = funGetValueWe("txtsaturday");

  var sun_val = sunday == ''? 0 :parseFloat(sunday);
  var mon_val = monday == ''? 0 :parseFloat(monday);
  var tue_val = tuesday == ''? 0 :parseFloat(tuesday);
  var wed_val = wednesday == ''? 0 :parseFloat(wednesday);
  var thur_val = thursday == ''? 0 :parseFloat(thursday);
  var fri_val = friday == ''? 0 :parseFloat(friday);
  var sat_val = saturday == ''? 0 :parseFloat(saturday);

  var total = parseFloat(sun_val)+parseFloat(mon_val)+parseFloat(tue_val)+parseFloat(wed_val)+parseFloat(thur_val)+parseFloat(fri_val)+parseFloat(sat_val);
  funSetValue("txtweektotal",total);
//  $('#tdsundaytotal').text(sunday);
  //console.log (total);
}


function funCreateAssignResource(){
  funShowLoader();
  var projectId = funGetValueWe('txtProjectId');
  var workItemId = funGetValueWe('txtWorkItemId');
  var activitiesId = funGetValueWe('txtActivitesId');
  var TableData = []; //initialize array;
  var jsonData=""; //empty var;

  $("tfoot#assignResourceEntries > tr").each(function(row, tr) {
    var ifChecked = $('td:eq(0) input:checked', this).val();
    if (ifChecked === 'on') {
       TableData[row]={
        "task_id": $('td:eq(1) select',this).val(),
        "emp_id": $('td:eq(2) input',this).val(),
        "start_date": $('td:eq(3) input',this).val(),
        "target_date": $('td:eq(4) input',this).val(),
        "hour": $('td:eq(5) input',this).val(),
        "weighter_score": $('td:eq(6) input',this).val(),
      };
      jsonData = JSON.stringify(TableData)
    }
  });

  // console.log(jsonData);
  if(funGetValueWe('project_id')==''){
     funHideLoader();
    funErrorMessage("Please select projectName");

  }
  else if(funGetValueWe('work_item')==''){
     funHideLoader();
    funErrorMessage("Please select workItem");

  }
  else if(funGetValueWe('activities_id')==''){
    funHideLoader();
   funErrorMessage("Please select Activity");

 } else{

  if(jsonData.length > 0) {
    $.ajax({              // Ajax call
      type: "POST",
      dataType:'JSON',
      url: baseURL+adminUrl+"/ajax/assign-employee/create",
      data: '_token='+funGetToken()+'&tableData='+jsonData+'&project_id='+projectId+'&work_item_id='+workItemId+'&activities_id='+activitiesId,
      success: function(response) {
        funHideLoader();
        console.log('res---',response);
        if (response.status == true) {
          window.location.href = baseURL+adminUrl+'/'+response.menu_url;
        } else {
          funErrorMessage(response.message);
        }
     }
    });
  } else {
    funHideLoader();
    funErrorMessage("Please add atleast one item")
  }
 }
}

function funRemoveReffComment(trId){
  $('#'+ trId).remove();
} 

function addCommentReff(day){
  funSetValue("day",day);
  var hours = $("#selreff"+day).val();
  var snoTimeEntry = $('#txtEditSnoComment').val();
  var sum = 0;
  $(".reff_hours_"+snoTimeEntry+"_"+day).each(function(){
    if($(this).val() !== "")
    {
      sum += parseFloat($(this).val());
    }
  });
  if(hours != "" && sum < hours)
  {
    funOpenModal("minModalCommentBookingHours");
  }
  else
  {
    alert("this timing is greated than "+day+" Entry Hours");
  }
}

function funEditTimeCardEntry(id){
  var project_id = $("#project_id"+id).val();
  console.log('project',project_id);
  var work_item_id = $("#work_item_id"+id).val();
  var activities_id = $("#activities_id"+id).val();
  var task_id = $("#task_id"+id).val();
  var sunday = $("#sunday"+id).val();
  var monday = $("#monday"+id).val();
  var tuesday = $("#tuesday"+id).val();
  var wednesday = $("#wednesday"+id).val();
  var thursday = $("#thursday"+id).val();
  var friday = $("#friday"+id).val();
  var saturday = $("#saturday"+id).val();
  var weektotal = $("#weektotal"+id).val();
  var comments = $("#comments"+id).val();
  var billing_type_id = $("#billable_type"+id).val();
  // console.log('df',billing_type_id);

  funSetValue("txtEditSno",id);
  
  funAjaxModalSelWorkItemAndTask(project_id,work_item_id);
  funAjaxModalSelActivities(work_item_id,activities_id);
  funAjaxModalSelTask(activities_id,task_id);

  funSetValue("editproject_id",project_id);
  funSetValue("editwork_item_id",work_item_id);
  funSetValue("editactivities_id",activities_id);
  funSetValue("edittask_id",task_id);
  funSetValue("selsunday",sunday);
  funSetValue("selmonday",monday);
  funSetValue("seltuesday",tuesday);
  funSetValue("selwednesday",wednesday);
  funSetValue("selthursday",thursday);
  funSetValue("selfriday",friday);
  funSetValue("selsaturday",saturday);
  funSetValue("selweektotal",parseFloat(weektotal));
  funSetValue("selcomments",comments);
  funSetValue("editbilling_type_id",billing_type_id);

  let projectBillableType= $('#editproject_id').find(':selected').attr('data-is_billable_project_type');

  if(Number(projectBillableType)) {
      $('#editbilling_type_id').find('option').removeAttr('disabled');
  } else {
    $('#editbilling_type_id').find('option').removeAttr('disabled');
    $('#editbilling_type_id').find('option').each(function() {
        // Get the value of the data-billable_type attribute
        var billableType = $(this).data('billable_type');
        var value = $(this).val();
      
        // If the billableType does not equal the projectBillableType, set the disabled attribute
        if ((billableType != projectBillableType) && (value)) {
          $(this).attr('disabled', true);
        }
    });
  }

  var option = $('#editbilling_type_id').find(`option[data-billable_type=${projectBillableType}]`);
  option.prop('selected', true);


  funOpenModal("modalEditBookingHoursTimeSheet");
}

function commentTimeCardEntryConfirm()
{
  var validateComments = true;
  var commentsMAndatoryId = funGetValue('companyCommentManadatory');
  var companyBookTicketId = funGetValue('companyBookTicket');
  var id = funGetValue('txtEditSnoComment');
  var project_id = funGetValueWe('comm_project_id');
  var work_item_id = funGetValueWe('comm_work_item_id');
  var activities_id = funGetValueWe('comm_activities_id');
  var task_id = funGetValueWe('comm_task_id');
  var billable_type= funGetValueWe("comm_bill_type_id");

  var sunday = funGetValueWe("selreffsunday");
  var monday = funGetValueWe("selreffmonday");
  var tuesday = funGetValueWe("selrefftuesday");
  var wednesday = funGetValueWe("selreffwednesday");
  var thursday = funGetValueWe("selreffthursday");
  var friday = funGetValueWe("selrefffriday");
  var saturday = funGetValueWe("selreffsaturday");
  // var comments= funGetValueWe("selcomments");
  var total= funGetValueWe("selreffweektotal");
  var sel_sunday_comment= funGetValueWe("sel_reff_sunday_comment");
  var sel_monday_comment= funGetValueWe("sel_reff_monday_comment");
  var sel_tuesday_comment= funGetValueWe("sel_reff_tuesday_comment");
  var sel_wednesday_comment= funGetValueWe("sel_reff_wednesday_comment");
  var sel_thursday_comment= funGetValueWe("sel_reff_thursday_comment");
  var sel_friday_comment= funGetValueWe("sel_reff_friday_comment");
  var sel_saturday_comment= funGetValueWe("sel_reff_saturday_comment");

  var sundayfinalInput = funGetValue("sunday_final_input_"+id);
  var mondayfinalInput = funGetValue("monday_final_input_"+id);
  var tuesdayfinalInput = funGetValue("tuesday_final_input_"+id);
  var wednesdayfinalInput = funGetValue("wednesday_final_input_"+id);
  var thursdayfinalInput = funGetValue("thursday_final_input_"+id);
  var fridayfinalInput = funGetValue("friday_final_input_"+id);
  var saturdayfinalInput = funGetValue("saturday_final_input_"+id);

  if(commentsMAndatoryId == 1)
  {
    $(".errorComments").remove();
    var weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    weekdays.forEach(day => {
      if($('#selreff'+day).val() > 0 && $('#sel_reff_'+day+'_comment').val() == "" && validateComments == true)
      {
        if(companyBookTicketId == 1)
        {
          $('#addCommentReff'+day).after('<span class="errorComments" style="color:red"><br>Please fill the comments</span>');
        }
        else
        {
          $('#sel_reff_'+day+'_comment').after('<span class="errorComments" style="color:red"><br>Please fill the comments</span>');
        }
        validateComments = false;
      }
    });
  }
  if(validateComments == true)
  {
    if(project_id!=''&& work_item_id!='' && activities_id!='' && task_id!='' && billable_type!=''){
      funSetValue('project_id'+id,project_id);
      funSetValue('work_item_id'+id,work_item_id);
      funSetValue('activities_id'+id,activities_id);
      funSetValue('task_id'+id,task_id);
      funSetValue('sunday'+id,sunday);
      funSetValue('sundayTest'+id,sunday);
      funSetValue('monday'+id,monday);
      funSetValue('mondayTest'+id,monday);
      funSetValue('tuesday'+id,tuesday);
      funSetValue('tuesdayTest'+id,tuesday);
      funSetValue('wednesday'+id,wednesday);
      funSetValue('wednesdayTest'+id,wednesday);
      funSetValue('thursday'+id,thursday);
      funSetValue('thursdayTest'+id,thursday);
      funSetValue('friday'+id,friday);
      funSetValue('fridayTest'+id,friday);
      funSetValue('saturday'+id,saturday);
      funSetValue('saturdayTest'+id,saturday);
      funSetValue('weektotal'+id,total);
      funSetValue('weektotalTest'+id,total);
      funSetValue('billable_type'+id,billable_type);
      funSetValue('sunday_comment'+id,sel_sunday_comment);
      funSetValue('monday_comment'+id,sel_monday_comment);
      funSetValue('tuesday_comment'+id,sel_tuesday_comment);
      funSetValue('wednesday_comment'+id,sel_wednesday_comment);
      funSetValue('thursday_comment'+id,sel_thursday_comment);
      funSetValue('friday_comment'+id,sel_friday_comment);
      funSetValue('saturday_comment'+id,sel_saturday_comment);

      for(i=1; i<= sundayfinalInput; i++)
      {
        var sandayReffHours= funGetValueWe("sunday_hours_"+id+"_"+i+"_modal");
        if($('#sunday_hours_'+id+'_'+i).length)
        {
          funSetValue('sunday_hours_'+id+'_'+i, sandayReffHours);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="sunday_hours_'+id+'_'+i+'" name="TimeSheetItem['+id+'][sunday_hours]['+i+']" value="">');
          funSetValue('sunday_hours_'+id+'_'+i, sandayReffHours);
        }
        
        var sandayReffComments= funGetValueWe("sunday_reff_"+id+"_"+i+"_modal");
        if($('#sunday_reff_'+id+'_'+i).length)
        {
          funSetValue('sunday_reff_'+id+'_'+i, sandayReffComments);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="sunday_reff_'+id+'_'+i+'" name="TimeSheetItem['+id+'][sunday_reff]['+i+']" value="">');
          funSetValue('sunday_reff_'+id+'_'+i, sandayReffComments);
        }
        
      }
      for(i=1; i<= mondayfinalInput; i++)
      {
        var mondayReffHours= funGetValueWe("monday_hours_"+id+"_"+i+"_modal");
        if($('#monday_hours_'+id+'_'+i).length)
        {
          funSetValue('monday_hours_'+id+'_'+i, mondayReffHours);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="monday_hours_'+id+'_'+i+'" name="TimeSheetItem['+id+'][monday_hours]['+i+']" value="">');
          funSetValue('monday_hours_'+id+'_'+i, mondayReffHours);
        }
        
        var mondayReffComments= funGetValueWe("monday_reff_"+id+"_"+i+"_modal");
        if($('#monday_reff_'+id+'_'+i).length)
        {
          funSetValue('monday_reff_'+id+'_'+i, mondayReffComments);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="monday_reff_'+id+'_'+i+'" name="TimeSheetItem['+id+'][monday_reff]['+i+']" value="">');
          funSetValue('monday_reff_'+id+'_'+i, mondayReffComments);
        }
      }
      for(i=1; i<= tuesdayfinalInput; i++)
      {
        var tuesdayReffHours= funGetValueWe("tuesday_hours_"+id+"_"+i+"_modal");
        if($('#tuesday_hours_'+id+'_'+i).length)
        {
          funSetValue('tuesday_hours_'+id+'_'+i, tuesdayReffHours);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="tuesday_hours_'+id+'_'+i+'" name="TimeSheetItem['+id+'][tuesday_hours]['+i+']" value="">');
          funSetValue('tuesday_hours_'+id+'_'+i, tuesdayReffHours);
        }
        
        var tuesdayReffComments= funGetValueWe("tuesday_reff_"+id+"_"+i+"_modal");
        if($('#tuesday_reff_'+id+'_'+i).length)
        {
          funSetValue('tuesday_reff_'+id+'_'+i, tuesdayReffComments);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="tuesday_reff_'+id+'_'+i+'" name="TimeSheetItem['+id+'][tuesday_reff]['+i+']" value="">');
          funSetValue('tuesday_reff_'+id+'_'+i, tuesdayReffComments);
        }
      }
      for(i=1; i<= wednesdayfinalInput; i++)
      {
        var wednesdayReffHours= funGetValueWe("wednesday_hours_"+id+"_"+i+"_modal");
        if($('#wednesday_hours_'+id+'_'+i).length)
        {
          funSetValue('wednesday_hours_'+id+'_'+i, wednesdayReffHours);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="wednesday_hours_'+id+'_'+i+'" name="TimeSheetItem['+id+'][wednesday_hours]['+i+']" value="">');
          funSetValue('wednesday_hours_'+id+'_'+i, wednesdayReffHours);
        }
        
        var wednesdayReffComments= funGetValueWe("wednesday_reff_"+id+"_"+i+"_modal");
        if($('#wednesday_reff_'+id+'_'+i).length)
        {
          funSetValue('wednesday_reff_'+id+'_'+i, wednesdayReffComments);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="wednesday_reff_'+id+'_'+i+'" name="TimeSheetItem['+id+'][wednesday_reff]['+i+']" value="">');
          funSetValue('wednesday_reff_'+id+'_'+i, wednesdayReffComments);
        }
      }
      for(i=1; i<= thursdayfinalInput; i++)
      {
        var thursdayReffHours= funGetValueWe("thursday_hours_"+id+"_"+i+"_modal");
        if($('#thursday_hours_'+id+'_'+i).length)
        {
          funSetValue('thursday_hours_'+id+'_'+i, thursdayReffHours);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="thursday_hours_'+id+'_'+i+'" name="TimeSheetItem['+id+'][thursday_hours]['+i+']" value="">');
          funSetValue('thursday_hours_'+id+'_'+i, thursdayReffHours);
        }
        
        var thursdayReffComments= funGetValueWe("thursday_reff_"+id+"_"+i+"_modal");
        if($('#thursday_reff_'+id+'_'+i).length)
        {
          funSetValue('thursday_reff_'+id+'_'+i, thursdayReffComments);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="thursday_reff'+id+'_'+i+'" name="TimeSheetItem['+id+'][thursday_reff]['+i+']" value="">');
          funSetValue('thursday_reff_'+id+'_'+i, thursdayReffComments);
        }
      }
      for(i=1; i<= fridayfinalInput; i++)
      {
        var fridayReffHours= funGetValueWe("friday_hours_"+id+"_"+i+"_modal");
        if($('#friday_hours_'+id+'_'+i).length)
        {
          funSetValue('friday_hours_'+id+'_'+i, fridayReffHours);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="friday_hours_'+id+'_'+i+'" name="TimeSheetItem['+id+'][friday_hours]['+i+']" value="">');
          funSetValue('friday_hours_'+id+'_'+i, fridayReffHours);
        }
        
        var fridayReffComments= funGetValueWe("friday_reff_"+id+"_"+i+"_modal");
        if($('#friday_reff_'+id+'_'+i).length)
        {
          funSetValue('friday_reff_'+id+'_'+i, fridayReffComments);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="friday_reff_'+id+'_'+i+'" name="TimeSheetItem['+id+'][friday_reff]['+i+']" value="">');
          funSetValue('friday_reff_'+id+'_'+i, fridayReffComments);
        }
      }
      for(i=1; i<= saturdayfinalInput; i++)
      {
        var saturdayReffHours= funGetValueWe("saturday_hours_"+id+"_"+i+"_modal");
        if($('#saturday_hours_'+id+'_'+i).length)
        {
          funSetValue('saturday_hours_'+id+'_'+i, saturdayReffHours);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="saturday_hours_'+id+'_'+i+'" name="TimeSheetItem['+id+'][saturday_hours]['+i+']" value="">');
          funSetValue('saturday_hours_'+id+'_'+i, saturdayReffHours);
        }
        
        var saturdayReffComments= funGetValueWe("saturday_reff_"+id+"_"+i+"_modal");
        if($('#saturday_reff_'+id+'_'+i).length)
        {
          funSetValue('saturday_reff_'+id+'_'+i, saturdayReffComments);
        }
        else
        {
          $('#tbodyTimeSheetEntries #TimeSheetItem'+id).append('<input type="hidden" id="saturday_reff'+id+'_'+i+'" name="TimeSheetItem['+id+'][saturday_reff]['+i+']" value="">');
          funSetValue('saturday_reff_'+id+'_'+i, saturdayReffComments);
        }
      }

      
      if(sel_sunday_comment!=""){
        $("#td_sundaycomments"+id).css({"background-color":"#32CD32"})

      }
      if(sel_monday_comment!=""){
        $("#td_mondaycomments"+id).css({"background-color":"#32CD32"})

      }
      if(sel_tuesday_comment!=""){
        $("#td_tuesdaycomments"+id).css({"background-color":"#32CD32"})

      }
      if(sel_wednesday_comment!=""){
        $("#td_wednesdaycomments"+id).css({"background-color":"#32CD32"})

      }
      if(sel_thursday_comment!=""){
        $("#td_thursdaycomments"+id).css({"background-color":"#32CD32"})

      }
      if(sel_friday_comment!=""){
        $("#td_fridaycomments"+id).css({"background-color":"#32CD32"})

      }
      if(sel_saturday_comment!=""){
        $("#td_saturdaycomments"+id).css({"background-color":"#32CD32"})

      }

    var project  = funGetValueWe('comm_project_id').split(' - ');
    var work_item = funGetValueWe('comm_work_item_id').split(' - ');
    var activities = funGetValueWe('comm_activities_id').split(' - ');
    var task = funGetValueWe('comm_task_id').split(' - ');
    var billable_type_name=funGetValueWe('comm_bill_type_id').split(' - ');
    var bill_name=billable_type_name.length < 2 ?'':billable_type_name[1];
    var project_name=project.length < 2 ?'':project[1];
    var work_item_name=work_item.length < 2 ?'':work_item[1];
    var activities_name=activities.length < 2 ?'':activities[1];
    var task_name=task.length < 2 ?'':task[1];
      $("#td_hours_taken"+id).html('');
      $("#td_project_name"+id).html(project_name);
      $("#td_workitem_name"+id).html(work_item_name);
      $("#td_activities_name"+id).html(activities_name);
      $("#td_task_name"+id).html(task_name);
      $("#td_sunday"+id).html(sunday);
      $("#td_monday"+id).html(monday);
      $("#td_tuesday"+id).html(tuesday);
      $("#td_wednesday"+id).html(wednesday);
      $("#td_thursday"+id).html(thursday);
      $("#td_friday"+id).html(friday);
      $("#td_saturday"+id).html(saturday);
      // $("#td_comments"+id).html(comments);
      $("#td_type"+id).html(bill_name);
      var gettotal=  getModalweektotal(1);
      $("#td_hours_taken"+id).html(total);

      var sundaycal=0;
      var mondaycal=0;
      var tuesdaycal=0;
      var wednesdaycal=0;
      var thursdaycal=0;
      var fridaycal=0;
      var saturdaycal=0;
      var weektotalcal=0;


      $('input[name^="sundayTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          sundaycal += $value;
    });

      $('input[name^="mondayTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          mondaycal += $value;
    });

        $('input[name^="tuesdayTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          tuesdaycal += $value;
    });
        $('input[name^="wednesdayTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          wednesdaycal += $value;
    });
            $('input[name^="thursdayTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          thursdaycal += $value;
    });
          $('input[name^="fridayTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          fridaycal += $value;
    });
          $('input[name^="saturdayTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          saturdaycal += $value;
    });

          $('input[name^="weektotalTest"]').each(function() {
          $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
          weektotalcal += $value;
    });
    if(sundaycal>24){
      funErrorMessage("Sunday work duration is exceed of 24 Hours");
    }
    else if(mondaycal>24){
      funErrorMessage("Monday work duration is exceed of 24 Hours");
    }
    else if(tuesdaycal>24){
      funErrorMessage("Tuesday work duration is exceed of 24 Hours");
    }
    else if(wednesdaycal>24){
      funErrorMessage("Wednesday work duration is exceed of 24 Hours");
    }
    else if(thursdaycal>24){
      funErrorMessage("Thursday work duration is exceed of 24 Hours");
    }
    else if(fridaycal>24){
      funErrorMessage("Friday work duration is exceed of 24 Hours");
    }
    else if(saturdaycal>24){
      funErrorMessage("Saturday work duration is exceed of 24 Hours");
    }
    else{

      $("#tdsundaytotal").html(sundaycal);
      $("#tdmondaytotal").html(mondaycal);
      $("#tdtuesdaytotal").html(tuesdaycal);
      $("#tdwednesdaytotal").html(wednesdaycal);
      $("#tdthursdaytotal").html(thursdaycal);
      $("#tdfridaytotal").html(fridaycal);
      $("#tdsaturdaytotal").html(saturdaycal);
      $("#tdtotalall").html(weektotalcal);
      $("#Spantot_hours").html(weektotalcal);
        funCloseModal("modalCommentBookingHours");
      }
    }
    else{

        if(project_id == '' )
        {
        funErrorMessage("Please select project");
        }
        else if(work_item_id == '' )
        {
        funErrorMessage("Please select Work item");
        }
        else if(activities_id == '' )
        {
        funErrorMessage("Please select Activities");
        }
        else if(task_id == '' )
        {
        funErrorMessage("Please select Task");
        }
        else if(billable_type == '' )
        {
        funErrorMessage("Please select Billable Type");
        }
    }
  }
}

function funCommentTimeCardEntry(id){
  
  var project_id = $("#project_id"+id).val();
  console.log('project',project_id);
  var work_item_id = $("#work_item_id"+id).val();
  var activities_id = $("#activities_id"+id).val();
  var task_id = $("#task_id"+id).val();
  var billing_type_id = $("#billable_type"+id).val();
  
  var project_name = $("#td_project_name"+id).html();
  var workitem_name = $("#td_workitem_name"+id).html();
  var activities_name = $("#td_activities_name"+id).html();
  var task_name = $("#td_task_name"+id).html();
  var type_name = $("#td_type"+id).html();

  var sunday = $("#sunday"+id).val();
  var monday = $("#monday"+id).val();
  var tuesday = $("#tuesday"+id).val();
  var wednesday = $("#wednesday"+id).val();
  var thursday = $("#thursday"+id).val();
  var friday = $("#friday"+id).val();
  var saturday = $("#saturday"+id).val();
  var weektotal = $("#weektotal"+id).val();
  var comments = $("#comments"+id).val();
  var sunday_comment = $("#sunday_comment"+id).val();
  var monday_comment = $("#monday_comment"+id).val();
  var tuesday_comment = $("#tuesday_comment"+id).val();
  var wednesday_comment = $("#wednesday_comment"+id).val();
  var thursday_comment = $("#thursday_comment"+id).val();
  var friday_comment = $("#friday_comment"+id).val();
  var saturday_comment = $("#saturday_comment"+id).val();
  var finalInput = $("#final_input_"+id).val();

  console.log('df',billing_type_id);

  funSetValue("txtEditSnoComment",id);
  
  funAjaxModalSelWorkItemAndTask(project_id,work_item_id);
  funAjaxModalSelActivities(work_item_id,activities_id);
  funAjaxModalSelTask(activities_id,task_id);


  $("#td_comm_project_name").html(project_name);
  $("#td_comm_workitem_name").html(workitem_name);
  $("#td_comm_activities_name").html(activities_name);
  $("#td_comm_task_name").html(task_name);
  $("#td_comm_type").html(type_name);
  
  $('.sundayHoursTable table').hide();
  $('.sundayHoursTable #sundayHoursTable'+id).show();
  $('.mondayHoursTable table').hide();
  $('.mondayHoursTable #mondayHoursTable'+id).show();
  $('.tuesdayHoursTable table').hide();
  $('.tuesdayHoursTable #tuesdayHoursTable'+id).show();
  $('.wednesdayHoursTable table').hide();
  $('.wednesdayHoursTable #wednesdayHoursTable'+id).show();
  $('.thursdayHoursTable table').hide();
  $('.thursdayHoursTable #thursdayHoursTable'+id).show();
  $('.fridayHoursTable table').hide();
  $('.fridayHoursTable #fridayHoursTable'+id).show();
  $('.saturdayHoursTable table').hide();
  $('.saturdayHoursTable #saturdayHoursTable'+id).show();


  funSetValue("comm_project_id", project_id);
  funSetValue("comm_work_item_id", work_item_id);
  funSetValue("comm_activities_id", activities_id);
  funSetValue("comm_task_id", task_id);
  funSetValue("comm_bill_type_id", billing_type_id);

  funSetValue("selreffsunday",sunday);
  funSetValue("selreffmonday",monday);
  funSetValue("selrefftuesday",tuesday);
  funSetValue("selreffwednesday",wednesday);
  funSetValue("selreffthursday",thursday);
  funSetValue("selrefffriday",friday);
  funSetValue("selreffsaturday",saturday);
  funSetValue("selreffweektotal",parseFloat(weektotal));
  funSetValue("selreffcomments",comments);
  funSetValue("sel_reff_sunday_comment",sunday_comment);
  funSetValue("sel_reff_monday_comment",monday_comment);
  funSetValue("sel_reff_tuesday_comment",tuesday_comment);
  funSetValue("sel_reff_wednesday_comment",wednesday_comment);
  funSetValue("sel_reff_thursday_comment",thursday_comment);
  funSetValue("sel_reff_friday_comment",friday_comment);
  funSetValue("sel_reff_saturday_comment",saturday_comment);

  var weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  weekdays.forEach(day => {
    if($('#selreff'+day).val() == 0 || $('#selreff'+day).val() == "")
    {
      $('#addCommentReff'+day).hide();
      $('#sel_reff_'+day+'_comment').hide();
      $('#'+day+'_comment_head').hide();
    }
    else
    {
      $('#addCommentReff'+day).show();
      $('#sel_reff_'+day+'_comment').show();
      $('#'+day+'_comment_head').show();
    }
    for(i=1; i<=finalInput; i++)
    {
      var hours = $("#"+day+"_hours_"+id+"_"+i).val();
      var refference = $("#"+day+"_reff_"+id+"_"+i).val();
      if(hours > 0)
      {
        var trId = 'tr_'+day+'_reff_'+id+'_'+i;
        if($('table#'+day+'HoursTable'+id).length)
        {
          $("#"+day+"HoursTable"+id+" tbody").attr("id", day+"HoursData"+id);
          $("#"+day+"HoursTable"+id+" tbody #"+trId).remove();
          $("#"+day+"HoursData"+id).append(
            '<tr id="'+trId+'" style="border:1px solid #bebeca">'+
            '<td>'+hours+'<input type="hidden" class="reff_hours_'+id+'_'+day+'"  name="'+day+'_hours[]" id="'+day+'_hours_'+id+'_'+i+'_modal" value="'+hours+'"></td>'+
            '<td>'+refference+'<input type="hidden" name="'+day+'_refference[]" id="'+day+'_reff_'+id+'_'+i+'_modal" value="'+refference+'"></td>'+
            '<td><span type="button" onclick="funRemoveReffComment(`'+trId+'`)" class="btn btn-danger btn-sm removeReff"> <i class="fa fa-close"> </i> </span></td>'+
            '</tr>'
          );
          $("#"+day+"_final_input_"+id).attr('value',i);
        }
        else
        {
          $("."+day+"HoursTable").append('<table class="col-lg-12" id="'+day+'HoursTable'+id+'" style="border:1px solid #bebeca"><thead><tr style="border:1px solid #bebeca"><td> Hours </td><td> Reference </td><td> Action </td></tr></thead><tbody class="'+day+'HoursData"></tbody></table>'+
          '<input type="hidden" id="'+day+'_final_input_'+id+'" value="">');
          $("#"+day+"HoursTable"+id+" tbody").attr("id", day+"HoursData"+id);
          $("#"+day+"HoursData"+id).append(
            '<tr id="'+trId+'" style="border:1px solid #bebeca">'+
            '<td>'+hours+'<input type="hidden" class="reff_hours_'+id+'_'+day+'" name="'+day+'_hours[]" id="'+day+'_hours_'+id+'_'+i+'_modal" value="'+hours+'"></td>'+
            '<td>'+refference+'<input type="hidden" name="'+day+'_refference[]" id="'+day+'_reff_'+id+'_'+i+'_modal" value="'+refference+'"></td>'+
            '<td><span type="button" onclick="funRemoveReffComment(`'+trId+'`)" class="btn btn-danger btn-sm removeReff"> <i class="fa fa-close"> </i> </span></td>'+
            '</tr>'
          );
          $("#"+day+"_final_input_"+id).attr('value',i);
        }
      }
    }
  });


  funOpenModal("modalCommentBookingHours");
}

function funAjaxModalSelWorkItemAndTask(id,work_item_id='')
{
  if (id)
  {

    var result = id.split(' - ');
                var project_id = result[0];
  var work_id =work_item_id.split(' - ');

  let projectBillableType= $('#editproject_id').find(':selected').attr('data-is_billable_project_type');

  if(Number(projectBillableType)) {
      $('#editbilling_type_id').find('option').removeAttr('disabled');
  } else {
      $('#editbilling_type_id').find('option').removeAttr('disabled');
      $('#editbilling_type_id').find('option').each(function() {
          // Get the value of the data-billable_type attribute
          var billableType = $(this).data('billable_type');
          var value = $(this).val();
        
          // If the billableType does not equal the projectBillableType, set the disabled attribute
          if ((billableType != projectBillableType) && (value)) {
            $(this).attr('disabled', true);
          }
      });
  }

  var option = $('#editbilling_type_id').find(`option[data-billable_type=${projectBillableType}]`);
  option.prop('selected', true);

  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/book-hours/ajax",
    data: '_token='+funGetToken()+'&project_id='+project_id,
    success: function(response) {
        if(response) {
            $('#editwork_item_id').empty();
            $('#editwork_item_id').focus;
            // $('#editactivities_id').empty();
            // $('#edittask_id').empty();
            $('#editwork_item_id').append('<option value="">--Select Workitem</option>');
            $.each(response, function(key, value){
            $option=$('<option value="'+ value.work_item_id +' - '+ value.work_item_name +'">' + value.work_item_name+ '</option>');
            if(work_id[0]== value.work_item_id){
              $option.attr('selected', 'selected');
            }
            $('#editwork_item_id').append($option);
         });
                  }else{
                    $('#editwork_item_id').empty();
                    $('#editactivities_id').empty();
                    $('#edittask_id').empty();
                  }
   }
  });

}else{
      $('#editwork_item_id').empty();
      $('#editactivities_id').empty();
      $('#edittask_id').empty();
     }

}


function funAjaxModalSelActivities(id,activities_id='')
{
  if (id)
  {

    var result = id.split(' - ');
                var work_item_id = result[0];
     var activities = activities_id.split(' - ');
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/book-hours/ajaxactivities",
    data: '_token='+funGetToken()+'&work_item_id='+work_item_id,
    success: function(response) {
        if(response) {
            $('#editactivities_id').empty();
            $('#editactivities_id').focus;
            $('#editactivities_id').append('<option value="">--Select Activities</option>');
            $.each(response, function(key, value){
            $option=$('<option value="'+ value.activities_id +' - '+ value.activities_name +'">' + value.activities_name+ '</option>');
            if(activities[0]==value.activities_id){
             $option.attr('selected', 'selected');
            }
            $('#editactivities_id').append($option);
         });
                  }else{
                    $('#editactivities_id').empty();
                     $('#edittask_id').empty();
                  }
   }
  });

}else{
      $('#editactivities_id').empty();
       $('#edittask_id').empty();
     }

}

function funAjaxModalSelTask(id,task_id='')
{
  if (id)
  {

    var result = id.split(' - ');
    var activities_id = result[0];
    var task=task_id.split(' - ');

  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/project/book-hours/ajaxtask",
    data: '_token='+funGetToken()+'&activities_id='+activities_id,
    success: function(response) {
      console.log(response);
        if(response) {
            $('#edittask_id').empty();
            $('#edittask_id').focus;
            $('#edittask_id').append('<option value="">--Select Task</option>');
            $.each(response, function(key, value){
            $option= $('<option value="'+ value.task_id +' - '+ value.task_name +'">' + value.task_name+ '</option>');
            if(task[0]==value.task_id){
               $option.attr('selected', 'selected');
            }
             $('#edittask_id').append($option);

         });
                  }else{
                    $('#edittask_id').empty();
                  }
   }
  });

}else{
      $('#edittask_id').empty();
     }

}

function getModalweektotal(val)
{

  funSetValue("selweektotal",'');
  var sunday = funGetValueWe("selsunday");
  var monday = funGetValueWe("selmonday");
  var tuesday = funGetValueWe("seltuesday");
  var wednesday = funGetValueWe("selwednesday");
  var thursday = funGetValueWe("selthursday");
  var friday = funGetValueWe("selfriday");
  var saturday = funGetValueWe("selsaturday");

  var sun_val = sunday == ''? 0 :parseFloat(sunday);
  var mon_val = monday == ''? 0 :parseFloat(monday);
  var tue_val = tuesday == ''? 0 :parseFloat(tuesday);
  var wed_val = wednesday == ''? 0 :parseFloat(wednesday);
  var thur_val = thursday == ''? 0 :parseFloat(thursday);
  var fri_val = friday == ''? 0 :parseFloat(friday);
  var sat_val = saturday == ''? 0 :parseFloat(saturday);

  var total = parseFloat(sun_val)+parseFloat(mon_val)+parseFloat(tue_val)+parseFloat(wed_val)+parseFloat(thur_val)+parseFloat(fri_val)+parseFloat(sat_val);

  funSetValue("selweektotal",total);
    return total;
}


function editTimeCardEntryConfirm()
{
  var id = funGetValue('txtEditSno');
  var project_id = funGetValueWe('editproject_id');
  var work_item_id = funGetValueWe('editwork_item_id');
  var activities_id = funGetValueWe('editactivities_id');
  var task_id = funGetValueWe('edittask_id');
  var sunday = funGetValueWe("selsunday");
  var monday = funGetValueWe("selmonday");
  var tuesday = funGetValueWe("seltuesday");
  var wednesday = funGetValueWe("selwednesday");
  var thursday = funGetValueWe("selthursday");
  var friday = funGetValueWe("selfriday");
  var saturday = funGetValueWe("selsaturday");
  var billable_type= funGetValueWe("editbilling_type_id");
  var total= funGetValueWe("selweektotal");
  var allotted_hours = funGetValueWe('edittd_allotted')
  var consumed_hours = funGetValueWe('edittd_consumed')
  var remaining_hours = funGetValueWe('edittd_remaining')

  if(project_id!=''&& work_item_id!='' && activities_id!='' && task_id!='' && billable_type!=''){
  funSetValue('project_id'+id,project_id);
  funSetValue('work_item_id'+id,work_item_id);
  funSetValue('activities_id'+id,activities_id);
  funSetValue('task_id'+id,task_id);
  funSetValue('sunday'+id,sunday);
  funSetValue('sundayTest'+id,sunday);
  funSetValue('monday'+id,monday);
  funSetValue('mondayTest'+id,monday);
  funSetValue('tuesday'+id,tuesday);
  funSetValue('tuesdayTest'+id,tuesday);
  funSetValue('wednesday'+id,wednesday);
  funSetValue('wednesdayTest'+id,wednesday);
  funSetValue('thursday'+id,thursday);
  funSetValue('thursdayTest'+id,thursday);
  funSetValue('friday'+id,friday);
  funSetValue('fridayTest'+id,friday);
  funSetValue('saturday'+id,saturday);
  funSetValue('saturdayTest'+id,saturday);
  funSetValue('weektotal'+id,total);
  funSetValue('weektotalTest'+id,total);
  funSetValue('billable_type'+id,billable_type);

 var project  = funGetValueWe('editproject_id').split(' - ');
 var work_item = funGetValueWe('editwork_item_id').split(' - ');
 var activities = funGetValueWe('editactivities_id').split(' - ');
 var task = funGetValueWe('edittask_id').split(' - ');
 var billable_type_name=funGetValueWe('editbilling_type_id').split(' - ');
 var bill_name=billable_type_name.length < 2 ?'':billable_type_name[1];
 var project_name=project.length < 2 ?'':project[1];
 var work_item_name=work_item.length < 2 ?'':work_item[1];
 var activities_name=activities.length < 2 ?'':activities[1];
 var task_name=task.length < 2 ?'':task[1];
  $("#td_hours_taken"+id).html('');
  $("#td_project_name"+id).html(project_name);
  $("#td_workitem_name"+id).html(work_item_name);
  $("#td_activities_name"+id).html(activities_name);
  $("#td_task_name"+id).html(task_name);
  $("#td_sunday"+id).html(sunday);
  $("#td_monday"+id).html(monday);
  $("#td_tuesday"+id).html(tuesday);
  $("#td_wednesday"+id).html(wednesday);
  $("#td_thursday"+id).html(thursday);
  $("#td_friday"+id).html(friday);
  $("#td_saturday"+id).html(saturday);

  $("#td_allotted"+id).html(allotted_hours);
  $("#td_consumed"+id).html(consumed_hours);
  $("#td_available"+id).html(remaining_hours);

  
  // $("#td_comments"+id).html(comments);
  $("#td_type"+id).html(bill_name);
  var gettotal=  getModalweektotal(1);
  $("#td_hours_taken"+id).html(total);

  var sundaycal=0;
  var mondaycal=0;
  var tuesdaycal=0;
  var wednesdaycal=0;
  var thursdaycal=0;
  var fridaycal=0;
  var saturdaycal=0;
  var weektotalcal=0;


  $('input[name^="sundayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       sundaycal += $value;
});

   $('input[name^="mondayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
      mondaycal += $value;
});

    $('input[name^="tuesdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       tuesdaycal += $value;
});
     $('input[name^="wednesdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       wednesdaycal += $value;
});
        $('input[name^="thursdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       thursdaycal += $value;
});
      $('input[name^="fridayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       fridaycal += $value;
});
       $('input[name^="saturdayTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       saturdaycal += $value;
});

       $('input[name^="weektotalTest"]').each(function() {
      $value = $(this).val()==''?parseFloat(0): parseFloat($(this).val());
       weektotalcal += $value;
});
if(sundaycal>24){
   funErrorMessage("Sunday work duration is exceed of 24 Hours");
}
else if(mondaycal>24){
   funErrorMessage("Monday work duration is exceed of 24 Hours");
}
else if(tuesdaycal>24){
   funErrorMessage("Tuesday work duration is exceed of 24 Hours");
}
else if(wednesdaycal>24){
   funErrorMessage("Wednesday work duration is exceed of 24 Hours");
}
else if(thursdaycal>24){
   funErrorMessage("Thursday work duration is exceed of 24 Hours");
}
else if(fridaycal>24){
   funErrorMessage("Friday work duration is exceed of 24 Hours");
}
else if(saturdaycal>24){
   funErrorMessage("Saturday work duration is exceed of 24 Hours");
}
else{

  $("#tdsundaytotal").html(sundaycal);
  $("#tdmondaytotal").html(mondaycal);
  $("#tdtuesdaytotal").html(tuesdaycal);
  $("#tdwednesdaytotal").html(wednesdaycal);
  $("#tdthursdaytotal").html(thursdaycal);
  $("#tdfridaytotal").html(fridaycal);
  $("#tdsaturdaytotal").html(saturdaycal);
  $("#tdtotalall").html(weektotalcal);
  $("#Spantot_hours").html(weektotalcal);
    funCloseModal("modalEditBookingHoursTimeSheet");
  }
 }
 else{

    if(project_id == '' )
    {
    funErrorMessage("Please select project");
    }
    else if(work_item_id == '' )
    {
    funErrorMessage("Please select Work item");
    }
    else if(activities_id == '' )
    {
    funErrorMessage("Please select Activities");
    }
    else if(task_id == '' )
    {
    funErrorMessage("Please select Task");
    }
    else if(billable_type == '' )
    {
    funErrorMessage("Please select Billable Type");
    }
  }
}

function funGetWorkItemTable() {

  var project_id = funGetValueWe('project_id');
  var work_item = funGetValueWe('work_item');
  if (work_item) {
    funShowLoader();

    $.ajax({                // Ajax call
      type: "get",
      url: baseURL + adminUrl + "/ajax/getall-approver-role",
      data: '_token=' + funGetToken() + '&work_item=' + work_item,
      success: function (response) {
        funHideLoader();
        if (response) {
          $('#tbodyviewEntries').empty();
          //     $('#showtabledetails').focus;
          $('#tbodyviewEntries').append('');
          var _template = '';
          $.each(response, function (key, value) {

         var secondary_role_owner_name = value.secondary_role_owner == null  ? "" :value.secondary_role_owner.emp_name;
         var primary_supervisor_name = value.primary_supervisor == null || value.primary_supervisor == 'undefined' || value.primary_supervisor == '' ? "":  value.primary_supervisor.emp_name;
         var secondary_supervisor_name = value.secondary_supervisor == null || value.secondary_supervisor == 'undefined' || value.secondary_supervisor == '' ? "": value.secondary_supervisor.emp_name ;

            _template += '<tr>';

            _template += '<td>' + value.project_owner.name + '</td>';
            _template += '<td>' + value.role_name + '</td>';
            _template += '<td>' + value.role_owner.emp_name  + '</td>';
            _template += '<td>' + secondary_role_owner_name+ '</td>';
            _template += '<td>' + primary_supervisor_name + '</td>';
            _template += '<td>' + secondary_supervisor_name + '</td>';

            _template += '<td><button type="button" class="btn btn-success btn-sm"  onclick="funOpenTeamModal(' + value.approver_role_id + ')"><i class="fa fa-users"></i></button></td>';

            _template += '</tr>';
          });
          $('#tbodyviewEntries').append(_template);
        }
        else {
          $('#tbodyviewEntries').empty();
        }

      }
    });
  }
  else {
    if(project_id!=''){
      funAjaxSelWorkItemAndTable(project_id)
    }
    else{
     $('#tbodyviewEntries').empty();
    }
    
  }

}

function addApproverRoleEntry() {

  var project_owner = funGetValueWe("project_owner");
  var role_name = funGetValueWe("role_name");
  var role_owner = funGetValueWe("role_owner");
  var secondary_role_owner = funGetValueWe("secondary_role_owner");
  var primary_supervisor = funGetValueWe("primary_supervisor");
  var secondary_supervisor = funGetValueWe("secondary_supervisor");


  if (project_owner == '') {
    funErrorMessage("Please select project owner");
  }
  else if (role_name == '') {
    funErrorMessage("Enter Role Name");
  }
  else if (role_owner == '') {
    funErrorMessage("Please select Approver");
  }
  else {

    var project_owner_name = project_owner.split(' - ');
    var role_owner_name = role_owner.split(' - ');
    var secondary_role_owner_name = secondary_role_owner.split(' - ');
    var primary_supervisor_name = primary_supervisor.split(' - ');
    var secondary_supervisor_name = secondary_supervisor.split(' - ');


    var _template = '<tr id="ApprovalEntrytItem' + sno + '">';
    _template += '<td id="td_project_owner' + sno + '">' + project_owner_name[1] + '</td>';
    _template += '<td id="td_role_name' + sno + '">' + role_name + '</td>';
    _template += '<td id="td_external' + sno + '">' + '' + '</td>';
    _template += '<td id="td_role_owner' + sno + '">' + role_owner_name[1] + '</td>';
    _template += '<td id="td_secondary_role_owner' + sno + '">' + (secondary_role_owner_name.length > 1 ? secondary_role_owner_name[1] : "") + '</td>';
    _template += '<td id="td_primary_supervisor' + sno + '">' + (primary_supervisor_name.length > 1 ? primary_supervisor_name[1] : "") + '</td>';
    _template += '<td id="td_secondary_supervisor' + sno + '">' + (secondary_supervisor_name.length > 1 ? secondary_supervisor_name[1] : "") + '</td>';
    _template += '<input  id="txtproject_owner' + sno + '" name="approvalEntrytItem[' + sno + '][project_owner]" value="' + project_owner + '" type="hidden" />';
    _template += '<input id="txtrole_name' + sno + '" name="approvalEntrytItem[' + sno + '][role_name]" value="' + role_name + '"  type="hidden" />';
    _template += '<input  id="txtrole_owner' + sno + '" name="approvalEntrytItem[' + sno + '][role_owner]" value="' + role_owner + '" type="hidden" />';
    _template += '<input  id="txtsecondary_role_owner' + sno + '" name="approvalEntrytItem[' + sno + '][secondary_role_owner]" value="' + secondary_role_owner + '" type="hidden" />';
    _template += '<input  id="txtprimary_supervisor' + sno + '" name="approvalEntrytItem[' + sno + '][primary_supervisor]" value="' + primary_supervisor + '" type="hidden"/>';
    _template += '<input  id="txtsecondary_supervisor' + sno + '" name="approvalEntrytItem[' + sno + '][secondary_supervisor]" value="' + secondary_supervisor + '" type="hidden"/>';

    _template += '<td><div style="display:inline-block;"><button type="button" onclick="funEditApprovalEntry(' + sno + ')" class="btn btn-primary btn-sm"> <i class="fa fa-edit"> </i> </button>';
    _template += ' </div><div style="display:inline-block;" ><button type="button" onclick="funRemoveApprovalEntrytItem(' + sno + ')" class="btn btn-danger btn-sm"> <i class="fa fa-close"> </i> </button> </div> </td>';

    $("#tbodyApprovalEntry").append(_template);

    clearApprovalEntrytItem();
    // gotoFocus('seltask_id');
    sno++;
  }
}

function funRemoveApprovalEntrytItem(sno) {
  $("#ApprovalEntrytItem" + sno).remove();
}

function editApprovalEntryConfirm() {
  var id = funGetValue('txtEditSno');

  var project_owner = funGetValueWe("selproject_owner");
  var role_name = funGetValueWe("selrole_name");
  var role_owner = funGetValueWe("selrole_owner");
  var secondary_role_owner = funGetValueWe("selsecondary_role_owner");
  var primary_supervisor = funGetValueWe("selprimary_supervisor");
  var secondary_supervisor = funGetValueWe("selsecondary_supervisor");

  var project_owner_name = project_owner.split(' - ');
  var role_owner_name = role_owner.split(' - ');
  var secondary_role_owner_name = secondary_role_owner.split(' - ');
  var primary_supervisor_name = primary_supervisor.split(' - ');
  var secondary_supervisor_name = secondary_supervisor.split(' - ');

  funSetValue('txtproject_owner' + id, project_owner);
  funSetValue('txtrole_name' + id, role_name);
  funSetValue('txtrole_owner' + id, role_owner);
  funSetValue('txtsecondary_role_owner' + id, secondary_role_owner);
  funSetValue('txtprimary_supervisor' + id, primary_supervisor);
  funSetValue('txtsecondary_supervisor' + id, secondary_supervisor);

  $("#td_project_owner" + id).html(project_owner_name[1]);
  $("#td_role_name" + id).html(role_name);
  $("#td_role_owner" + id).html(role_owner_name[1]);
  $("#td_secondary_role_owner" + id).html(secondary_role_owner == '' ? '' : secondary_role_owner_name[1]);
  $("#td_primary_supervisor" + id).html(primary_supervisor == '' ? '' : primary_supervisor_name[1]);
  $("#td_secondary_supervisor" + id).html(secondary_supervisor == '' ? '' : secondary_supervisor_name[1]);

  funCloseModal("modalEditApprovalEntry");

}

function funOpenTeamModal(sno) {

  var empArray = new Array();
  var project_id =$("#project_id").val();
  var work_item_id =$("#work_item").val();
  if (sno) {
    $.ajax({                // Ajax call
      type: "get",
      url: baseURL + adminUrl + "/ajax/get-approver-roleById",
      data: '_token=' + funGetToken() + '&id=' + sno+'&project_id='+project_id+'&work_item_id='+work_item_id,
      success: function (response) {
        funHideLoader();
        if (response) {
          $("#modalTeam").modal('show');
          $('#team_member').empty();
          $("#team_approver_role_id").val('');
          $("#team_project_id").val('');
          $("#team_role_name").val();
          $("#divprojectName").text('');
          $("#divroleName").text('');

          $.each(response, function (key, list) {
            if (list != undefined) {
              empArray.push(list.emp_id);
            }
          })
          // console.log('employee',empArray)
          $.each(response.emp_list, function (key, list) {
            $option = $('<option value="' + list.emp_id + '" >' + list.emp_name + '</option>');
            if (empArray.includes(list.emp_id)) {
              $option.attr('selected', 'selected');
            }
            $('#team_member').append($option);
          });
          $("#team_approver_role_id").val(response.approver_role_id);
          $("#team_project_id").val(response.project_id);
          $("#team_work_item_id").val(response.work_item_id);
          $("#team_role_name").val(response.role_name);
          $("#divprojectName").text(response.project_name);
          $("#divroleName").text(response.role_name);

        }


      }
    });
  }
}

function funModifyTeamMembers() {
  var team_member = $('#team_member').val();
  var approver_role_id = $('#team_approver_role_id').val();
  var team_work_item_id = $('#team_work_item_id').val();
  var team_project_id = $('#team_project_id').val();


  $.ajax({
    type: 'POST',
    url: baseURL + adminUrl + '/project/approver-team/page-process/ADDAJAX',

    data: {
      "_token": funGetToken(),
      "team_approver_role_id": approver_role_id,
      "team_member": team_member,
      "team_work_item_id": team_work_item_id
    },
    dataType: 'json',
    success: function (response) {
      console.log(response);
      if (response) {
        $("#modalTeam").modal("hide");
        if (response.status == 'danger') {
          new Noty({
            layout: 'topRight',
            theme: 'alert bg-danger text-white p-0',
            text: response.msg,
            timeout: 3000
          }).show();
        }
        if (response.status == 'success') {
          new Noty({
            layout: 'topRight',
            theme: 'alert bg-success text-white p-0',
            text: response.msg,
            timeout: 3000
          }).show();
        }
      }

    }
  });
}

function clearApprovalEntrytItem() {
  funSetValue("project_owner", "");
  funSetValue("role_name", "");
  funSetValue("role_owner", "");
  funSetValue("secondary_role_owner", "");
  funSetValue("primary_supervisor", "");
  funSetValue("secondary_supervisor", "");

}

function funEditApprovalEntry(id) {


  var project_owner = $("#txtproject_owner" + id).val();
  var role_name = $("#txtrole_name" + id).val();
  var role_owner = $("#txtrole_owner" + id).val();
  var secondary_role_owner = $("#txtsecondary_role_owner" + id).val();
  var primary_supervisor = $("#txtprimary_supervisor" + id).val();
  var secondary_supervisor = $("#txtsecondary_supervisor" + id).val();

  funSetValue("txtEditSno", id);
  funSetValue("selproject_owner", project_owner);
  funSetValue("selrole_name", role_name);
  funSetValue("selrole_owner", role_owner);
  funSetValue("selsecondary_role_owner", secondary_role_owner);
  funSetValue("selprimary_supervisor", primary_supervisor);
  funSetValue("selsecondary_supervisor", secondary_supervisor);

  $("#modalEditApprovalEntry").modal("show");
}

function funGetProjectCompanyDep(id){
  // console.log(id);
  funShowLoader();
  if (id) {
    $.ajax({                // Ajax call
      type: "GET",
      url: baseURL+adminUrl+"/ajax/get-company-dep",
      data: '_token='+funGetToken()+'&id='+id,
      success: function(response) {
        if(response) {
          funHideLoader();
          $('#department').empty();
          $('#department').focus();
          $('#department').append('<option value="">-- Select Department --</option>');
          $.each(response, function(key, value){
          $('select[name="dep_id"]').append('<option value="'+ value.dep_id +' - '+ value.dep_name +'">' + value.dep_name+ '</option>');
         });
        }else{
          funHideLoader();
          $('#department').empty();
        }
     }
    });
  }
}

function funExportLeaveReport(){
  const projectId = funGetValueWe('txtLeaveProjectId');
  const workItemId = funGetValueWe('txtLeaveWorkItemId');
  const empId = funGetValueWe('txtEmpId');
  const fromDate = funGetValueWe('txtLeaveFromDate');
  const toDate = funGetValueWe('txtLeaveToDate');
  // console.log(projectId,workItemId,empId,fromDate,toDate);
  $.ajax({                // Ajax call
      type: "GET",
      url: baseURL+adminUrl+"/ajax/leave-report-export",
      data: '_token='+funGetToken()+'&project_id='+projectId+'&work_item_id='+workItemId+'&emp_id='+empId+'&from_date='+fromDate+'&to_date='+toDate,
      success: function(response) {
        console.log(response);
        // if(response) {
        //   funHideLoader();
        //   $('#department').empty();
        //   $('#department').focus();
        //   $('#department').append('<option value="">-- Select Department --</option>');
        //   $.each(response, function(key, value){
        //   $('select[name="dep_id"]').append('<option value="'+ value.dep_id +' - '+ value.dep_name +'">' + value.dep_name+ '</option>');
        //  });
        // }else{
        //   funHideLoader();
        //   $('#department').empty();
        // }
     },
     error: function(err){
      funHideLoader();
      console.log(err);
      // funErrorMessage("Something went wrong please try after sometime");
     },
    });
}

function funAjaxSelWorkItemAndTable(id)
{
  if (id) {
  funShowLoader();
  $.ajax({                // Ajax call
    type: "GET",
    url: baseURL+adminUrl+"/ajax/getall-approver-role-by-projectid",
    data: '_token='+funGetToken()+'&project_id='+id,
    success: function(response) {
      funHideLoader();
        if(response) {

            $('#work_item').empty();
            $('#selemp_id').empty();
            $('#activities_id').empty();
            $('#work_item').focus;
            $('#work_item').append('<option value="">-- Select Workitem --</option>');
            $.each(response.workItem, function(key, value){
            $('select[name="work_item_id"]').append('<option value="'+ value.work_item_id +'">' + value.work_item_name+ '</option>');
         });
            $('#selemp_id').focus;
            $('#selemp_id').append('<option value="">-- Select Resources --</option>');
            $.each(response.resources, function(key,value){
              $('select[name="emp_id"]').append('<option value="'+value.emp_id+' - '+value.emp_name+'">' + value.emp_name+ '</option>');
            });
             $('#tbodyviewEntries').empty();
          //     $('#showtabledetails').focus;
          $('#tbodyviewEntries').append('');
           var _template = '';
             $.each(response.tablevalues, function (key, value) {

         var secondary_role_owner_name = value.secondary_role_owner == null  ? "" :value.secondary_role_owner.emp_name;
         var primary_supervisor_name = value.primary_supervisor == null || value.primary_supervisor == 'undefined' || value.primary_supervisor == '' ? "":  value.primary_supervisor.emp_name;
         var secondary_supervisor_name = value.secondary_supervisor == null || value.secondary_supervisor == 'undefined' || value.secondary_supervisor == '' ? "": value.secondary_supervisor.emp_name ;

            _template += '<tr>';

            _template += '<td>' + value.project_owner.name + '</td>';
            _template += '<td>' + value.role_name + '</td>';
            _template += '<td>' + value.role_owner.emp_name  + '</td>';
            _template += '<td>' + secondary_role_owner_name+ '</td>';
            _template += '<td>' + primary_supervisor_name + '</td>';
            _template += '<td>' + secondary_supervisor_name + '</td>';

            _template += '<td><button type="button" class="btn btn-success btn-sm"  onclick="funOpenTeamModal(' + value.approver_role_id + ')"><i class="fa fa-users"></i></button></td>';

            _template += '</tr>';
          });
          $('#tbodyviewEntries').append(_template);
                  }else{
                    funHideLoader();
                    $('#work_item').empty();
                    $('#activities_id').empty();
                    $('#tbodyviewEntries').empty();
                  }
   }
  });

}else{
    funHideLoader();
      $('#work_item').empty();
      $('#activities_id').empty();
      $('#tbodyviewEntries').empty();
     }

}

function funSubmitBookingHours(){
  
  var selproject_id = $("#selproject_id").val();
  var selwork_item_id = $("#selwork_item_id").val();
  var selactivities_id = $("#selactivities_id").val();
  var seltask_id = $("#seltask_id").val();
  var commentsMandatory = $("#companyCommentManadatory").val();
  var lastRow = $("#tbodyTimeSheetEntries tr:last").attr('id');
  var lastId = lastRow.split("TimeSheetItem");
  
  if(selproject_id !='' && selwork_item_id !='' && selactivities_id !='' && seltask_id !=''){
    let result=confirm('kindly click on add button to save all the entries');           
    if(result){
      return false;
    }
  }
  if(commentsMandatory == 1)
  {
    var timesheetMandatory = 0;
    var weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    weekdays.forEach(day => {
      for(var i=0; i <= lastId[1]; i++)
      {
        if(($("#"+day+i).val() != "" && $("#"+day+i).val() > 0) && $("#"+day+'_comment'+i).val() == "")
        {
          timesheetMandatory = 1;
        }
      }
    });
    console.log(timesheetMandatory);
  }
  if(timesheetMandatory == 1)
  {
    alert('kindly update your timesheet comments');
    return false;
  }
  return true;
 
}

function funGetExternalResource(){
    funShowLoader();
    var userTypeId = 2;
    var projectId = funGetValueWe("project_id");
    if (projectId == "") {
        funErrorMessage("Please select project name");
        funHideLoader();
    } else if (!$('#txtExternalResource').is(":checked")){
        funHideLoader();
        // funErrorMessage("Please select project name");
    } else {
        if ($('#txtExternalResource').is(":checked")) {
            $.ajax({
                type: "GET",
                url: baseURL+adminUrl+"/ajax/external-resources",
                data: '_token='+funGetToken()+"&user_type_id="+userTypeId+"&project_id="+projectId,
                success: function(response) {
                    if(response.status) {
                        funHideLoader();
                        $('#role_owner').empty();
                        $('#role_owner').focus();
                        $('#role_owner').append('<option value="">-- Select Approver --</option>');
                        $.each(response.data, function(key, value){
                        $('select[name="role_owner"]').append('<option value="'+ value.emp_id+' - '+ value.emp_name+'">' + value.emp_name+ '</option>');
                        });
                    } else {
                      funHideLoader();
                      funErrorMessage(response.message);
                      $('#role_owner').empty();
                    }
                },
                error: function(err){
                    funHideLoader();
                    console.log(err);
                    funErrorMessage("Something went wrong please try after sometime");
                },
            });
        } else {
            funHideLoader();
        }
    }
}


function appusersvalidation(){
    $region_id=$("#region_id").val();
    $user_type_id=$("#user_type_id").val();
    $first_name=$("#first_name").val();
    $last_name=$("#last_name").val();
    $gender=$("#gender").val();
    $role_id=$("#role_id").val();
    $username=$("#username").val();
    $password=$("#password").val();
    $company=$("#company").val();
    $department=$("#department").val();
      
    if($region_id==''){
      funErrorMessage("Please select region");
      return false;
    }
    else if($user_type_id==''){
      funErrorMessage("Please select user type");
      return false;
    }
    else if($first_name==''){
      funErrorMessage("Please enter first name");
      return false;
    }
    else if($last_name==''){
      funErrorMessage("Please enter last name");
      return false;
    }
    else if($gender==''){
      funErrorMessage("Please select gender");
      return false;
    }
    else if($role_id==''){
      funErrorMessage("Please select role");
      return false;
    }
    
    else if($username==''){
      funErrorMessage("Please enter username");
      return false;
    }
    else if($password==''){
      funErrorMessage("Please enter password");
      return false;
    }
    else if($company.length == 0){
      funErrorMessage("Please select company");
      return false;
    }
    else if($department.length == 0){
      funErrorMessage("Please select department");
      return false;
    }
    else{
       $("#appusers").submit();
       return true;
    }
}

function funClientTimesheetApproveManager(status,id)
{
  funShowLoader();
  var comment =funGetValueWe('approvercomment');
  var emp_id =funGetValueWe('emp_id');
  console.log('ji');
  $.ajax({
    type: "POST",
    url: baseURL+adminUrl+"/client/approve-timesheet",
    data: '_token='+funGetToken()+'&id='+id+'&status='+status+'&comments='+comment+'&emp_id='+emp_id,
    success: function(response) {
      funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
          // window.location.href = baseURL+adminUrl+'/project/approve-hours';
          window.location.reload(true);
          $("#butApprove"+id).remove();
          $("#butRejectNeedReview"+id).remove();
          $(".ajax_resp").html(response.status_msg);
         // $("#butReview"+id).remove();
          $("#spanStatus"+id).html(response.status_msg);
        }
    },
    error: function() {
      funHideLoader();
      // packiaraj 28Apr2021 funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funGetEmpDepartment(id){

  var company_id = $("#emp_company").val();
  if (company_id !="") {
    $.ajax({                // Ajax call
      type: "get",
      url: baseURL + adminUrl + "/ajax/get-department",
      data: '_token=' + funGetToken() + '&company_id=' + company_id,
      success: function (response) {
        // console.log(response);
        if (response) {
          $('#emp_department').empty();
          $('#emp_department').focus;
          $('#emp_department').append('<option value="">-- Select Department --</option>');
          $.each(response.company, function (key, value) {
            // $('#emp_department').append('<optgroup label="' + value.company_name + '">');
            $.each(value.departments, function (key, list) {
              $option = $('<option value="' + list.dep_id + '">' + list.dep_name + '</option>');
              // if (department_values.includes(list.dep_id.toString())) {
              //   $option.attr('selected', 'selected');
              // }
              $('#emp_department').append($option);
            });
            // $('#emp_department').append('</optgroup>');
          });

        }
        else {
          $('#emp_department').empty();
        }
      }
    });
    $.ajax({                // Ajax call
      type: "get",
      url: baseURL + adminUrl + "/ajax/get-leave-policy",
      data: '_token=' + funGetToken() + '&company_id=' + company_id,
      success: function (response) {
        // console.log(response);
        if (response) {
          $('#emp_leave_policy').empty();
          $('#emp_leave_policy').focus;
          $('#emp_leave_policy').append('<option value="">-- Select Leave Policy --</option>');
          $.each(response.company, function (key, value) {
            // $('#emp_department').append('<optgroup label="' + value.company_name + '">');
            $.each(value.departments, function (key, list) {
              $option = $('<option value="' + list.leave_policy_id + '">' + list.policy_name + '</option>');
              // if (department_values.includes(list.dep_id.toString())) {
              //   $option.attr('selected', 'selected');
              // }
              $('#emp_leave_policy').append($option);
            });
            // $('#emp_department').append('</optgroup>');
          });

        }
        else {
          $('#emp_leave_policy').empty();
        }
      }
    });
  }
  else {
    $('#emp_department').empty();
  }
}

function funGetEmpDepartmentFilter(id){

  var company_id = $("#filter_company_id").val();
  if (company_id !="") {
    $.ajax({                // Ajax call
      type: "get",
      url: baseURL + adminUrl + "/ajax/get-department",
      data: '_token=' + funGetToken() + '&company_id=' + company_id,
      success: function (response) {
        // console.log(response);
        if (response) {
          $('#filter_department_id').empty();
          $('#filter_department_id').focus;
          $('#filter_department_id').append('<option value="">-- Select Department --</option>');
          $.each(response.company, function (key, value) {
            // $('#emp_department').append('<optgroup label="' + value.company_name + '">');
            $.each(value.departments, function (key, list) {
              $option = $('<option value="' + list.dep_id + '">' + list.dep_name + '</option>');
              // if (department_values.includes(list.dep_id.toString())) {
              //   $option.attr('selected', 'selected');
              // }
              $('#filter_department_id').append($option);
            });
            // $('#emp_department').append('</optgroup>');
          });

        }
        else {
          $('#emp_department').empty();
        }
      }
    });
  }
  else {
    $('#emp_department').empty();
  }
}

function funGetBookHoursPermission($value){
 let result= confirm("You have applied leave on this date. do you want to proceed?");
  
}

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  var regionFormateDate = $('#regionFormateDate').val();

  if(regionFormateDate == "mm-dd-yyyy")
  {
    return [month, day, year].join('-');
  }
  else
  {
    return [day, month, year].join('-');
  }
}

function funSubmitLeaveRequest(){

  $('#leaveSubmit').prop('disabled',true);
  if($("#project_id").val()==''){

    funErrorMessage('Project can not be null');
     $('#leaveSubmit').prop('disabled',false);
  }
  else if($("#txtWorkItem").val()==''){

     funErrorMessage('Work item can not be null');
      $('#leaveSubmit').prop('disabled',false);
  }
  else if($("#txtPrimaryApp").val()==''){

     funErrorMessage('Primary supervisor  item can not be null');
      $('#leaveSubmit').prop('disabled',false);
  }
  
  else if($("#fromDate").val()==''){
    funErrorMessage('From date can not be null');
     $('#leaveSubmit').prop('disabled',false);
    
  }
  else if($("#toDate").val()==''){
    funErrorMessage('To date can not be null');
     $('#leaveSubmit').prop('disabled',false);
    
  }
  else if($("#reason").val()==''){
    funErrorMessage('Reason can not be null');
     $('#leaveSubmit').prop('disabled',false);
  }
  else if($("#leave_type").val()==''){
    funErrorMessage('Select Leave Type');
     $('#leaveSubmit').prop('disabled',false);
  }
  else{
    funShowLoader();
  // $("#leaveRequestForm").submit();
  let from_date=$('#fromDate').val();
  let to_date=$('#toDate').val();
  
  $.ajax({                                // Ajax call
            type: "GET",
            dataType: "JSON",
            url: baseURL+adminUrl+"/ajax/get-bookhours-dates",
             data:'_token='+funGetToken()+'&from_date='+from_date+'&to_date='+to_date,
                success: function(response) {
                 funHideLoader();
                    if(response.status==true)
                    {
                      
                        let result=confirm('You have created Timesheet on the date(s). do you want to proceed?');
                        console.log('true',result);
                        if(result){
                          $("#leaveRequestForm").submit();
                        }
                        else{
                          $('#leaveSubmit').prop('disabled',false);
                        }
                        
                    }
                    else if(response.status==false)
                    {
                          $("#leaveRequestForm").submit();

                    }
                },
            error: function() {
                funHideLoader();
                $('#leaveSubmit').prop('disabled',false);
                funErrorMessage("Error occured !!! Please try after sometime.");
            }
        });
  }
}

function funSubmitEmpLeaveRequest(){

  $('#empLeaveSubmit').prop('disabled',true);
  if($("#project_id").val()==''){

    funErrorMessage('Project can not be null');
     $('#empLeaveSubmit').prop('disabled',false);
  }
  else if($("#txtWorkItem").val()==''){

     funErrorMessage('Work item can not be null');
      $('#empLeaveSubmit').prop('disabled',false);
  }
  else if($("#txtPrimaryApp").val()==''){

     funErrorMessage('Primary supervisor  item can not be null');
      $('#empLeaveSubmit').prop('disabled',false);
  }
  
  else if($("#fromDate").val()==''){
    funErrorMessage('From date can not be null');
     $('#empLeaveSubmit').prop('disabled',false);
    
  }
  else if($("#toDate").val()==''){
    funErrorMessage('To date can not be null');
     $('#empLeaveSubmit').prop('disabled',false);
    
  }
  else if($("#reason").val()==''){
    funErrorMessage('Reason can not be null');
     $('#empLeaveSubmit').prop('disabled',false);
  }
  else if($("#leave_type").val()==''){
    funErrorMessage('Select Leave Type');
     $('#empLeaveSubmit').prop('disabled',false);
  }
  else{
    funShowLoader();
  let fromDate=$('#fromDate').val();
  let from_date = formatDate(fromDate);
  let toDate=$('#toDate').val();
  let to_date = formatDate(toDate);
  let regionFormateDate = $('#regionFormateDate').val();
  
  $.ajax({                                // Ajax call
            type: "GET",
            dataType: "JSON",
            url: baseURL+adminUrl+"/ajax/get-bookhours-dates",
             data:'_token='+funGetToken()+'&from_date='+from_date+'&to_date='+to_date,
                success: function(response) {
                 funHideLoader();
                    if(response.status==true)
                    {
                      
                        let result=confirm('You have created Timesheet on the date(s). do you want to proceed?');
                        console.log('true',result);
                        if(result){
                          $("#empLeaveRequestForm").submit();
                        }
                        else{
                          $('#empLeaveSubmit').prop('disabled',false);
                        }
                        
                    }
                    else if(response.status==false)
                    {
                          $("#empLeaveRequestForm").submit();

                    }
                },
            error: function() {
                funHideLoader();
                $('#empLeaveSubmit').prop('disabled',false);
                funErrorMessage("Error occured !!! Please try after sometime.");
            }
        });
  }
}

function funCancelBookHours(){

  var duplicateCount = $('#duplicate_count').val();
  var selproject_id = $("#selproject_id").val();
  var selwork_item_id = $("#selwork_item_id").val();
  var selactivities_id = $("#selactivities_id").val();
  var seltask_id = $("#seltask_id").val();
  
  if(selproject_id !='' && selwork_item_id !='' && selactivities_id !='' && seltask_id !=''){
    let result=confirm('kindly click on add button to save all the entries');
                       
      if(result){
        if(duplicateCount > 0)
        {
          alert('You have duplicate timesheeet please submit once');
        }
        return false;

      }
      else{
        if(duplicateCount > 0)
        {
          alert('You have duplicate timesheeet please submit once');
          return false;
        }
        window.location = baseURL+adminUrl+"/project/booking-hours";
      }

  }else{
    if(duplicateCount > 0)
    {
      alert('You have duplicate timesheeet please submit once');
      return false;
    }
    window.location = baseURL+adminUrl+"/project/booking-hours";
    // $('#bookinghoursubmit').prop('disabled',true);
    // $("#bookinghoursForm").submit();
    
  // 
  }

}

function funApplyResignation(date)
{
  var releaveDate = moment(date, regionDateFromat.toUpperCase());
  var get_releaveDate= releaveDate.format('DD-MM-YYYY');
    releave = get_releaveDate.split("-");
    releave_date = new Date(releave[2], releave[1] - 1, releave[0]);  

  var result = new Date(releave_date);
    result.setDate(result.getDate() + 60);
    
  var formattedDate = new Date(result);
    // d = formattedDate.getDate();
    // m =  formattedDate.getMonth();
    // m += 1;
    // var y = formattedDate.getFullYear();
    // if (d < 10) {
    //   d = "0" + d;
    // }
    // if (m < 10) {
    //   m = "0" + m;
    // }
    // var finalDate = d + "-" + m + "-" + y;
    var empDateFormat = $("#finalDay").attr('data-empDateFormat');
    var finalDate = moment(result).format(empDateFormat);
    $("#finalDay").val(finalDate);
}

function funEmpResignationApproveManager(status,id)
{
  funShowLoader();
  funSetValue('approver_status', status);
    var formData = $('#approverResignationForm').serialize();

  $.ajax({
    type: "POST",
    url: baseURL+adminUrl+"/ajax/resignation-approval",
    data: formData,
    success: function(response) {
      funHideLoader();
      if(response.status == true) {
        funSuccessMessage(response.message);
        window.location.href = baseURL+adminUrl+'/'+response.menu_url;
        $("#butApprove"+id).remove();
        $("#butRejectNeedReview"+id).remove();
        $(".ajax_resp").html(response.status_msg);
        $("#butReview"+id).remove();
        $("#spanStatus"+id).html(response.status_msg);

        // console.log(response.status_msg);
        // console.log(response.message);
      } else {
        funHideLoader();
        funErrorMessage("Something went wrong");
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funEmpResignationHrApproveManager(status,id)
{
  funShowLoader();
  var finalDay = $('#finalDay').val();
  funSetValue('hr_approver_status', status);

  var formData = $('#ResignationHrApprovalForm').serialize();

  $.ajax({
    type: "POST",
    url: baseURL+adminUrl+"/ajax/hr-resignation-approval",
    data: formData,
    success: function(response) {
      funHideLoader();
      if(response.status == true) {
        funSuccessMessage(response.message);
        window.location.href = baseURL+adminUrl+'/'+response.menu_url;
        $("#butApprove"+id).remove();
        $("#butRejectNeedReview"+id).remove();
        $(".ajax_resp").html(response.status_msg);
        $("#butReview"+id).remove();
        $("#spanStatus"+id).html(response.status_msg);

        // console.log(response.status_msg);
        // console.log(response.message);
      } else {
        funHideLoader();
        funErrorMessage("Something went wrong");
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage("Error occured !!! Please try after sometime.");
      // console.log("Error occured !!! Please try after sometime.");
    }
  });
}

function funApplyWarranty() 
{
    var purchasedDate = $('#purchased_date').val();
    var warrantyPeriod = $('#warranty_period').val(); 

    if((purchasedDate) && (warrantyPeriod)) {
       purchasedDate = moment(purchasedDate, regionDateFromat2.toUpperCase());

      
      var warrantyDays = warrantyPeriod*365;

      var purchaseDateFormat = purchasedDate.format('DD-MM-YYYY');

      var purchaseDateDetails = purchaseDateFormat.split("-");

      var purchase_date = new Date(purchaseDateDetails[2], purchaseDateDetails[1] - 1, purchaseDateFormat[0]);
      var result = new Date(purchase_date);
      result.setDate(result.getDate() + warrantyDays);

      var formattedDate = new Date(result);

        d = formattedDate.getDate();
        m =  formattedDate.getMonth();
        m += 1;

      var y = formattedDate.getFullYear();
      if (d < 10) {
          d = "0" + d;
      }
      if (m < 10) {
          m = "0" + m;
      }

      var warrantyExpiredDate = d + "-" + m + "-" + y;

      $("#warranty_expired_date").val(warrantyExpiredDate);
    } else {
      $("#warranty_expired_date").val('');
    }
}

function funTimesheetApproveReportingManager(status,timesheet_id,id)
{
    funShowLoader();
    var comment =funGetValueWe('reportingmanagercomment');
    $.ajax({
      type: "POST",
      url: baseURL+adminUrl+"/project/manager-approval/approve-timesheet",
      data: '_token='+funGetToken()+'&timesheetid='+timesheet_id+'&id='+id+'&status='+status+'&comments='+comment,
      success: function(response) {
        funHideLoader();
        if(response.status == true) {
          funSuccessMessage(response.message);
          window.location.href = baseURL+adminUrl+'/project/manager-approval';
          $("#butApprove"+id).remove();
        $("#butRejectNeedReview"+id).remove();
          $(".ajax_resp").html(response.status_msg);
          $("#spanStatus"+id).html(response.status_msg);
        }
      },
      error: function() {
        funHideLoader();
      }
    });
}

function revokeResignationModal(resignationId) {
  funSetValue('resignation_id', resignationId);
  funSetValue('revoke_reason', '');
  funOpenModal("revokeResignationModal");
}

function funGetProjectMember($projectId) {
	$.ajax({
    	type: "GET",
    	url: baseURL+adminUrl+"/project-management/ajax/project-detail/project-members/"+$projectId,
    	success: function(response) {
    		let projectMembers = response.projectMembers

    		let project = response.projectDetail
  
        	html='';
        	$('ul.project-members-list').html('');
        	$('h5 span.project-name').text('');
        	$.each(projectMembers, function(index, member) {

        		let designation = member.designation ? member.designation : '';
        		let officialMail = member.official_email ? member.official_email : '';

        		let userIconColors = ['bg-danger-300', 'bg-warning-300', 'bg-info-300', 'bg-slate-300 ', 'bg-pink-300', 'bg-violet-300', 'bg-teal-300', 'bg-green-300', 'bg-orange-300', 'bg-grey-300', 'bg-purple-300'];
        		let randomColor = userIconColors[Math.floor(Math.random() * userIconColors.length)];

            	html += '<li class="media p-2">';
            	html += '<div class="mr-3">';
            	html += '<a href="javascript:void(0)" class="btn btn-sm rounded-round btn-icon '+ randomColor +'">';
            	html += '<i class="icon-user"></i>';
            	html += '</a></div>';

            	html += '<div class="row media-body">';
            	html += '<div class="col-5">';
            	html += '<div class="media-title font-weight-semibold">'+member.emp_name+'</div>';
            	html += '<span class="text-muted">'+ designation +'</span>';
            	html += '</div>';
            	html += '<div class="col-7 align-self-center">';
            	html += '<div class="list-icons list-icons-extended text-left">';
            	if(officialMail){
            		html += '<a href="mailto:'+ officialMail + '"class="list-icons-item text-dark" data-popup="tooltip" title="Mail" data-toggle="modal" data-trigger="hover" data-target="#call">';
            		html += '<i class="icon-mail5 px-2"></i>';
            		html += officialMail;
            	} else {
            		html += '<a href="mailto:javascript:void(0)"class="pl-3 list-icons-item text-danger text-center" data-popup="tooltip" title="Mail" data-toggle="modal" data-trigger="hover" data-target="#call">';
            		html += 'Mail Address Not Found';
            	}
            	html += '</div>';
            	html += '</div>'
            	html += '</li>';
        	});

        	$('ul.project-members-list').append(html);

        	funHideLoader();

        	$('#team_member_list').modal('show');
    	},
    	error: function() {
      		funHideLoader();
      		funErrorMessage("Error occured !!! Please try after sometime.");
    	}
  	});

}

function createBoardModal(projectId) {
	$('span.board-type-title').text('Create Board')
	funSetValue('project_id', projectId);
	funSetValue('type', 'ADD');
  	funSetValue('board_id', '');
  	funSetValue('board_description', '');
  	funSetValue('board_name', '');
    funSetValue('board_code', '');
  	funSetValue('board_member_id', '');
    $("#board_member_id").val(null).trigger("change"); 
	funOpenModal("createBoardModal");
}

function editProjectBoard(boardId) {
	$('span.board-type-title').text('Edit Board')
	var url = baseURL+adminUrl+"/project-management/project-detail/board/get-detail/"+boardId;

	$.ajax({
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/project-management/project-detail/board/get-detail/"+boardId,
      data:'_token='+funGetToken(),
      success: function(response) {
        // console.log(response);
          if (response.boardDetail) {
          	var boardDetail = response.boardDetail
          	funSetValue('type', 'EDIT');
          	funSetValue('project_id', boardDetail.project_id);
          	funSetValue('board_id', boardDetail.board_id);
          	funSetValue('board_description', boardDetail.board_description);
          	funSetValue('board_name', boardDetail.board_name);
            funSetValue('board_code', boardDetail.board_code);
          	var selectedValues=boardDetail.board_member_id;
          	$.each(selectedValues.split(","), function(i,e){
    			$("#board_member_id option[value='" + e + "']").prop("selected", true).change();
			});
			$("#board_status option[value='" + boardDetail.status + "']").prop("selected", true).change();


          } else {
          	alert('No board details found!')
          }
      },
      error: function() {
      }
    });
	funOpenModal("createBoardModal");
}

function deleteBoardModal(boardId, boardName) {
  funSetValue('delete_board_id', boardId);
  $("h6 span.delete-board-name").text(boardName);
funOpenModal("deleteBoardModal");
}

function deleteItemModal(itemId, itemName) {
  funSetValue('delete_item_id', itemId);
  $("h6 span.delete-item-name").text(itemName);
funOpenModal("deleteItemModal");
}

function funGetBoardMember(boardId) {
	$.ajax({
    	type: "GET",
    	url:  baseURL+adminUrl+"/project-management/project-detail/board/get-detail/"+boardId,
    	success: function(response) {
    		let boardMembers = response.boardMembers

    		let boardDetail = response.boardDetail
  
        	html='';
        	$('ul.board-members-list').html('');
        	$('h5 span.board-name').text('');
        	$.each(boardMembers, function(index, member) {

        		let designation = member.designation ? member.designation : '';
        		let officialMail = member.official_email ? member.official_email : '';

        		let userIconColors = ['bg-danger-300', 'bg-warning-300', 'bg-info-300', 'bg-slate-300 ', 'bg-pink-300', 'bg-violet-300', 'bg-teal-300', 'bg-green-300', 'bg-orange-300', 'bg-grey-300', 'bg-purple-300'];
        		let randomColor = userIconColors[Math.floor(Math.random() * userIconColors.length)];

            	html += '<li class="media p-2">';
            	html += '<div class="mr-3">';
            	html += '<a href="javascript:void(0)" class="btn btn-sm rounded-round btn-icon '+ randomColor +'">';
            	html += '<i class="icon-user"></i>';
            	html += '</a></div>';

            	html += '<div class="row media-body">';
            	html += '<div class="col-5">';
            	html += '<div class="media-title font-weight-semibold">'+member.emp_name+'</div>';
            	html += '<span class="text-muted">'+ designation +'</span>';
            	html += '</div>';
            	html += '<div class="col-7 align-self-center">';
            	html += '<div class="list-icons list-icons-extended text-left">';
            	if(officialMail){
            		html += '<a href="mailto:'+ officialMail + '"class="list-icons-item text-dark" data-popup="tooltip" title="Mail" data-toggle="modal" data-trigger="hover" data-target="#call">';
            		html += '<i class="icon-mail5 px-2"></i>';
            		html += officialMail;
            	} else {
            		html += '<a href="mailto:javascript:void(0)"class="pl-3 list-icons-item text-danger text-center" data-popup="tooltip" title="Mail" data-toggle="modal" data-trigger="hover" data-target="#call">';
            		html += 'Mail Address Not Found';
            	}
            	html += '</div>';
            	html += '</div>'
            	html += '</li>';
        	});

        	$('ul.board-members-list').append(html);

        	funHideLoader();

        	$('#board_member_list').modal('show');
    	},
    	error: function() {
      		funHideLoader();
      		funErrorMessage("Error occured !!! Please try after sometime.");
    	}
  	});

}

function createBoardSprintModal(boardId) {
	$('span.sprint-type-title').text('Create Sprint')
	funSetValue('board_id', boardId);
	funSetValue('process_type', 'ADD');
  	funSetValue('sprint_name', '');
  	funSetValue('sprint_start_date', '');
  	funSetValue('sprint_start_date', '');
  	funSetValue('sprint_goal', '')
	funOpenModal("boardSprintModal");
}

function editBoardSprint(sprintId) {
	$('span.sprint-type-title').text('Edit Sprint')
	var url = baseURL+adminUrl+"/project-management/project-detail/board/get-detail/"+sprintId;

	$.ajax({
      type: "GET",
      dataType: "JSON",
      url: baseURL+adminUrl+"/project-management/project-detail/board/sprint/get-detail/"+sprintId,
      data:'_token='+funGetToken(),
      success: function(response) {
          if (response) {
          	var sprintDetail = response
          	funSetValue('process_type', 'EDIT');
          	funSetValue('board_id', sprintDetail.board_id);
          	funSetValue('sprint_id', sprintDetail.sprint_id);
          	funSetValue('sprint_name', sprintDetail.sprint_name);
          	let empDateFormat =  $("#sprint_start_date").attr('data-empDateFormat');
    		let sprintStartDate = moment(sprintDetail.sprint_start_date).format(empDateFormat);
    		let sprintEndDate =  moment(sprintDetail.sprint_end_date).format(empDateFormat);
            funSetValue('sprint_start_date', sprintStartDate);
          	funSetValue('sprint_end_date', sprintEndDate);
          	funSetValue('sprint_goal', sprintDetail.sprint_goal);
          } else {
          	alert('No board details found!')
          }
      },
      error: function() {
      }
    });
	funOpenModal("boardSprintModal");
}

function createBoardItem(e, ItemTypeId, ItemTypeName) {
  let title = 'Create '+ ItemTypeName;
  let onlySelfParent = $(e).attr('data-only_self_parent');
  $('span.item-type-title').text(title);
  funSetValue('item_process_type', 'ADD');
  funSetValue('item_type_id', ItemTypeId);
  funSetValue('item_type_name', ItemTypeName);
  funSetValue('item_title', '');
  funSetValue('item_parent_id', '');
  funSetValue('item_sprint_id', '');
  funSetValue('item_assigned_to', '');
  funSetValue('item_start_date', '');
  funSetValue('item_due_date', '');
  funSetValue('item_attachment', '');
  funSetValue('item_epic_id', '');

  if((onlySelfParent) && (onlySelfParent == 1)) {
      $('.item-epic-field').css("display", "none");
      $("#item_epic_id").attr('disabled','disabled');
      $('.item-parent-field').css("display", "block");
  } else {
      console.log('not-ok', onlySelfParent);
     
      $('.item-parent-field').css("display", "none");
      $('.item-epic-field').css("display", "block");
      $("#item_epic_id").removeAttr('disabled');
  }

funOpenModal("boardItemModal");
}

function editBoardItem(itemId, ItemTypeName) {
  let title = 'Edit '+ ItemTypeName;
$('span.item-type-title').text(title);
var url = baseURL+adminUrl+"/project-management/project-detail/board/item/get-detail/"+itemId;

$.ajax({
    type: "GET",
    dataType: "JSON",
    url: url,
    data:'_token='+funGetToken(),
    success: function(response) {
        if (response) {
          let onlySelfParent = response.item_type.only_self_parent;

          if((onlySelfParent) && (onlySelfParent == 1)) {
              $('.item-epic-field').css("display", "none");
              $("#item_epic_id").attr('disabled','disabled');
              $('.item-parent-field').css("display", "block");
          } else {
              console.log('not-ok', onlySelfParent);
             
              $('.item-parent-field').css("display", "none");
              $('.item-epic-field').css("display", "block");
              $("#item_epic_id").removeAttr('disabled');
          }
          
          funSetValue('item_process_type', 'EDIT');
          funSetValue('item_id', response.item_id);
          funSetValue('item_type_id', response.item_type_id);
          funSetValue('item_type_name', ItemTypeName);
          funSetValue('item_title',  response.item_title);
          let empDateFormat =  $("#item_start_date").attr('data-empDateFormat');
      let itemStartDate = (response.item_start_date) ? moment(response.item_start_date).format(empDateFormat) : '';
      let itemDueDate =  (response.item_due_date) ? moment(response.item_due_date).format(empDateFormat) : '';
          funSetValue('item_start_date', itemStartDate);
          funSetValue('item_due_date', itemDueDate);
          funSetValue('item_epic_id', response.item_epic_id);
          if(response.item_assigned_to) {
            $("#item_assigned_to option[value='" + response.item_assigned_to + "']").prop("selected", true).change();
          } else {
            $("#item_assigned_to option[value='']").prop("selected", true).change();
          }
          $("#item_sprint_id option[value='" + response.item_sprint_id + "']").prop("selected", true).change();
          $("#item_parent_id option[value='" + response.item_parent_id + "']").prop("selected", true).change();
          $("#item_epic_id option[value='" + response.item_epic_id + "']").prop("selected", true).change();
          $("#item_status_id option[value='" + response.item_status_id + "']").prop("selected", true).change();
          funSetValue('item_attachment', '');
          funSetValue('item_description',  response.item_description);
          
        } else {
          alert('No board details found!')
        }
    },
    error: function() {
    }
  });
funOpenModal("boardItemModal");
}

function deleteSprintModal(sprintId, sprintName) {
  funSetValue('delete_sprint_id', sprintId);
  $("h6 span.delete-sprint-name").text(sprintName);
  funOpenModal("deleteSprintModal");
}

function updateBoardItem(itemId, itemFieldName, itemFieldValue) {
  funShowLoader();
  let data = {"_token": funGetToken(), "itemId":itemId, "itemFieldName":itemFieldName, itemFieldValue:itemFieldValue};

  // Ajax call
  $.ajax({                            
      type: "POST",
      dataType: "JSON",
      url: baseURL+adminUrl+"/project-management/project-detail/board/item/status-update",
      data:data,
      success: function(response) {
          funHideLoader();
          toastr.options.timeOut = 1000000;
          if(response.status==true)
              toastr.success(response.message);
          else
              toastr.error(response.message);
              
          window.location.reload();

      },
      error: function() {
          funHideLoader();
          funErrorMessage("Error occured !!! Please try after sometime.");
      }
  });
}


function updateBoardStatusOrder(boardId, newOrder) {
  funShowLoader();
  let data = {"_token": funGetToken(), "boardId":boardId, "order":newOrder};

  $.ajax({
    url: baseURL+adminUrl+"/project-management/project-detail/board/status-order/sort",
    type: 'POST',
    dataType: "JSON",
    data:data,
    success: function(response) {
      funHideLoader();
      toastr.options.timeOut = 1000000;
      if(response.status==true)
          toastr.success(response.message);
      else
          toastr.error(response.message);
    },
    error: function() {
      funHideLoader();
          funErrorMessage("Error occured !!! Please try after sometime.");
    }
  });
}

function funGetIpProjectType(ipTypeId) {

  if (ipTypeId) {
    $.ajax({                // Ajax call
      type: "GET",
      url: baseURL + adminUrl + "/ajax/get-ip-project-type",
      data: '_token=' + funGetToken() + '&ipTypeId=' + ipTypeId,
      success: function (response) {
          let defualtSel= '<option value="">-- Select Project Type --</option>';
          $('#project_type_id').empty();
          $('#project_type_id').append(defualtSel);

          if(response.data.length > 0) {
              $.each(response.data, function (key, value) {
                  $('select[name="project_type_id"]').append(`<option value=${value.project_type_id}>${value.project_type_name}</option>`);
              });
          }

      }
    });
  }
  else {
      let defualtSel= '<option value="">-- Select Project Type --</option>';
      $('#project_type_id').empty();
      $('#project_type_id').append(defualtSel);
  }

  funToggleRefProduct();

}

function funToggleRefProduct() {
  let projectIpType = $('#project_ip_type_id').val();
  let projectType = $('#project_type_id').val();

  if((projectIpType == 1) && (projectType == 1)) {
      $('div.ref-product').removeClass('d-none');
      $('#ref_product_id').prop('required',true);

  } else {
      if(!($('div.ref-product').hasClass('d-none'))) {
          $('div.ref-product').addClass('d-none');
      }

      $('#ref_product_id').val('');
      $('#ref_product_id').removeAttr('required');
  }

}

function funHideToolTip() {
  var tooltips = document.querySelectorAll('.tooltip');
  tooltips.forEach(function (tooltip) {
      tooltip.style.display = 'none';
  });
}

function funGetExpenseWorkItem(id, work_item_id="")
{
  funShowLoader();
  if (id)
  {
    var result = id.split(' - ');
    var project_id = result[0];
    var work_id =work_item_id.split(' - ');
      
    $.ajax({
      type: "GET",
      url: baseURL+adminUrl+"/project/book-hours/ajax",
      data: '_token='+funGetToken()+'&project_id='+project_id,
      success: function(response) {
        if(response) {
          funHideLoader();
            $('#work_item_id').empty();
            $('#work_item_id').append('<option value="">--Select Work Item</option>');
            $.each(response, function(key, value){
                option=$('<option value="'+ value.work_item_id +' - '+ value.work_item_name +'">' + value.work_item_name+ '</option>');
                if(work_id[0]== value.work_item_id){
                    option.attr('selected', 'selected');
                }
                $('#work_item_id').append(option);
            })
            $('#expense_activity_id').empty();
            $('#expense_activity_id').append('<option value="">--Select Expense Activity--</option>'); 
            funSetValue('txtExpPrimaryApp','');
            funSetValue('txtExpSecondaryApp','');
        } else {
            $('#work_item_id').empty();
            $('#expense_activity_id').empty(); 
            $('#work_item_id').append('<option value="">--Select Work Item--</option>');
            $('#expense_activity_id').append('<option value="">--Select Expense Activity--</option>'); 
            funSetValue('txtExpPrimaryApp','');
            funSetValue('txtExpSecondaryApp','');
        }
      },
      error: function() {
        funHideLoader();
      }
    });
      
  } else {
    funHideLoader();
      $('#work_item_id').empty();
      $('#expense_activity_id').empty();
      $('#work_item_id').append('<option value="">--Select Work Item--</option>');
      $('#expense_activity_id').append('<option value="">--Select Expense Activity--</option>');
      funSetValue('txtExpPrimaryApp','');
      funSetValue('txtExpSecondaryApp','');
  }
}

function funGetExpenseActivity(workItemId, expense_activity="")
{
  funShowLoader();
  if (workItemId)
  {
    var result = workItemId.split(' - ');
    var work_item_id = result[0];
    var expense_activity_id =expense_activity.split(' - ');
      
    $.ajax({
      type: "GET",
      url: baseURL+adminUrl+"/ajax/expense/get-expense-activity",
      data: '_token='+funGetToken()+'&work_item_id='+work_item_id,
      success: function(response) {
        funHideLoader();
        if(response.data) {
            $('#expense_activity_id').empty();
            $('#expense_activity_id').append('<option value="">--Select Expense Activity--</option>');
            $.each(response.data, function(key, value){
                option=$('<option value="'+ value.expense_activity_id +' - '+ value.expense_activity_name +'">' + value.expense_activity_name+ '</option>');
                if(expense_activity_id== value.expense_activity_id){
                    option.attr('selected', 'selected');
                }
                $('#expense_activity_id').append(option);
            })
        } else {
            $('#expense_activity_id').empty();
            $('#expense_activity_id').append('<option value="">--Select Expense Activity--</option>'); 
            funSetValue('txtExpPrimaryApp','');
            funSetValue('txtExpSecondaryApp','');  
        }
    }, 
    error: function() {
        funHideLoader();
    }
    });
      
  } else {
      funHideLoader();
      $('#expense_activity_id').empty();
      $('#expense_activity_id').append('<option value="">--Select Expense Activity--</option>');
      funSetValue('txtExpPrimaryApp','');
      funSetValue('txtExpSecondaryApp','');
  }

}

function getExpenseApprover(expenseActivity){
  funShowLoader();
  var result = expenseActivity.split(' - ');
  var expense_activity_id = result[0];
  $.ajax({
    type: "GET",
    url: baseURL+adminUrl+"/ajax/expense/get-expense-approver",
    data: '_token='+funGetToken()+'&expense_activity_id='+expense_activity_id,
    success: function(response) {
      funHideLoader();
      if(response.status) {
        funSetValue('txtExpPrimaryApp','');
        funSetValue('txtExpSecondaryApp','');

        $('#txtExpPrimaryAppId').focus;
        funSetValue('txtExpPrimaryApp',response.data.priApp.emp_name);
        funSetValue('txtExpPrimaryAppId',response.data.priApp.emp_id);
        $('#txtExpSecondaryAppId').focus;
        if (response.data.secApp != '' || response.data.secApp != null){
          funSetValue('txtExpSecondaryApp',response.data.secApp.emp_name);
          funSetValue('txtExpSecondaryAppId',response.data.secApp.emp_id);
        } else {
          funSetValue('txtExpSecondaryApp','');
          funSetValue('txtExpSecondaryAppId','');
        }
      } else {
        funHideLoader();
        funSetValue('txtExpPrimaryApp','');
        funSetValue('txtExpPrimaryAppId','');
        funSetValue('txtExpSecondaryApp','');
        funSetValue('txtExpSecondaryAppId','');
      }
    },
    error: () => {
        funShowLoader();
    }
  });
}

function funExpenseUpdatePayment(status, id) {
  funShowLoader();
  $.ajax({
    type: 'POST',
    dataType: 'JSON',
    url: baseURL+adminUrl+'/ajax/expense/payment_update',
    data: '_token='+funGetToken()+'&expense_id='+id+'&payment_status='+status,
    success: function(response) {
      funHideLoader();
      if (response.status == true) {
        funSuccessMessage(response.message);
        setTimeout(function() {
            location.reload();
        }, 5000);
      } else {
        funHideLoader();
        funErrorMessage('Something went wrong');
      }
    },
    error: function() {
      funHideLoader();
      funErrorMessage('Error occured !!! Please try after sometime.');
    }
  });
}

function funGetTaskHourDetails(taskIdDetail, isEdit=false) {
  let activityIdDetail = (isEdit) ? $('#editactivities_id').val() : $('#selactivities_id').val();
  let activityId = activityIdDetail.split('-')[0]
  let taskId = taskIdDetail.split('-')[0]

  if(activityId && taskId) {
      $.ajax({
          type: "GET",
          url: baseURL+adminUrl+"/ajax/booking-hours/get-task-hours-details",
          data: '_token='+funGetToken()+'&activity_id='+activityId+'&task_id='+taskId,
          success: function(response) {
            funHideLoader();
            if(response.data) {
              if(isEdit) {
                  $('#edittd_allotted').val(response.data.allotted_hours)
                  $('#edittd_consumed').val(response.data.consumed_hours)
                  $('#edittd_remaining').val(response.data.available_hours)
              } else {
                  $('#tdalloted').text(response.data.allotted_hours)
                  $('#tdconsumed').text(response.data.consumed_hours)
                  $('#tdavailable').text(response.data.available_hours)
              }
            } else {
              if(isEdit) {
                  $('#edittd_allotted').val(0.00)
                  $('#edittd_consumed').val(0.00)
                  $('#edittd_remaining').val(0.00)
              } else {
                  $('#tdalloted').text(0.00)
                  $('#tdconsumed').text(0.00)
                  $('#tdavailable').text(0.00)
              }
             
            }
        }, 
        error: function() {
            funHideLoader();
        }
        });
  }
}